<template>
    <div>
        <Fieldset :legend="$t('searchHeader')" :toggleable="true" id="component">
            <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2" @keyup.enter="saveData_Modal('search')">
                <div class="p-formgrid p-grid p-col">
                    <div class="p-col-12 p-lg-6 p-mt-2">
                        <div class="p-formgrid p-grid">
                            <div class="p-field p-col-10 p-lg-10">
                                <label class="p-mr-2">หน่วยงานที่รับผิดชอบ</label>
                                <Button
                                    @click="
                                        showOrganize = true;
                                        setOpenModal_OrganizeMulti = 'search';
                                    "
                                    icon="pi pi-plus"
                                    class="p-button-success"
                                    ref="TextBox_1_search"
                                    @keyup.left="moveFocus($event, 'TextBox_4_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_3_search', 'Button')"
                                />
                            </div>
                        </div>
                        <div class="p-field p-col p-mt-2" style="margin-left: -10px">
                            <DataTable
                                :value="organize_table"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="3"
                                dataKey="id"
                                :rowHover="true"
                                :selection.sync="selectedOrganizeData"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="organize_name" :header="$t('id_operating_name')" :sortable="true" headerStyle="width: 20rem">
                                    <template #body="dataTable">
                                        <div hidden>{{ dataTable.data.organize_id }}</div>
                                        {{ dataTable.data.organize_name }}
                                    </template>
                                </Column>
                                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div class="p-formgrid p-grid">
                                            <div class="p-field p-col-6">
                                                <Button
                                                    @click="
                                                        // displayConfirmation = true;
                                                        deleteAt = 'organize';
                                                        organizeDelete = dataTable.data;
                                                        alertDisplay(organizeDelete, deleteAt);
                                                    "
                                                    icon="pi pi-trash"
                                                    :label="$t('deleteBtn')"
                                                    class="p-button-rounded p-button-danger"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>

                    <!-- <div class="p-col p-mt-3 p-ml-3"> -->
                    <div class="p-col-12 p-lg-6 p-mt-3">
                        <div class="p-grid p-col">
                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="equipment_name">{{ $t('iev_equipment_name') }}</label>
                                <InputText
                                    id="equipment_name"
                                    type="text"
                                    v-model="equipment_name"
                                    ref="TextBox_2_search"
                                    @keyup.left="moveFocus($event, 'TextBox_1_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_3_search', 'Button')"
                                    @keyup.up="moveFocus($event, 'TextBox_1_search', 'Button')"
                                    @keyup.down="moveFocus($event, 'TextBox_3_search', 'Button')"
                                />
                            </div>
                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="iev_status_Search">{{ $t('iev_equipment_status') }}</label>

                                <Dropdown
                                    v-model="iev_status_Search"
                                    optionLabel="name"
                                    :options="iev_StatusOptions_Search"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                    :filter="true"
                                    :showClear="true"
                                >
                                    <template #value="iev_StatusOptions_Search">
                                        <div v-if="iev_StatusOptions_Search.value">
                                            <div>{{ iev_StatusOptions_Search.value.name }}</div>
                                        </div>
                                        <span v-else>
                                            {{ iev_StatusOptions_Search.placeholder }}
                                        </span>
                                    </template>
                                    <template #option="iev_StatusOptions_Search">
                                        <div>{{ iev_StatusOptions_Search.option.name }}</div>
                                    </template>
                                </Dropdown>
                            </div>
                        </div>

                        <div class="p-field p-col-12 p-lg-12 p-mt-2">
                            <label for="equipment_group">{{ $t('iev_equipment_group') }}</label>
                            <Dropdown
                                v-model="equipmentGroupSelected"
                                :options="equipmentGroupOptions"
                                optionLabel="system_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="equipmentGroupOptions">
                                    <div v-if="equipmentGroupOptions.value">
                                        <div>{{ equipmentGroupOptions.value.system_name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ equipmentGroupOptions.placeholder }}
                                    </span>
                                </template>
                                <template #option="equipmentGroupOptions">
                                    <div>{{ equipmentGroupOptions.option.system_name }}</div>
                                </template>
                            </Dropdown>
                        </div>

                        <div class="p-grid p-col p-mt-2">
                            <div v-if="setDiv_EGS(equipmentGroupSelected)" :class="iev_sideNum_Style">
                                <label for="equipment_type">{{ $t('iev_equipment_type') }}</label>
                                <Dropdown
                                    :disabled="disabledEquiptype == 1"
                                    v-model="equipmentTypeSelected"
                                    :options="equipmentTypeOptions"
                                    optionLabel="system_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="equipmentTypeOptions">
                                        <div v-if="equipmentTypeOptions.value">
                                            <div>{{ equipmentTypeOptions.value.system_name }}</div>
                                        </div>
                                        <span v-else>
                                            {{ equipmentTypeOptions.placeholder }}
                                        </span>
                                    </template>
                                    <template #option="equipmentTypeOptions">
                                        <div>{{ equipmentTypeOptions.option.system_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>

                            <div v-if="equipmentTypeSelected !== null && iev_sideNum_Search !== null" class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="equipment_type">หมายเลขข้างรถ/เรือ</label>
                                <Dropdown
                                    v-model="iev_sideNum_Search_Selector"
                                    :options="iev_sideNum_Search"
                                    optionLabel="system_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="iev_sideNum_Search">
                                        <div v-if="iev_sideNum_Search.value">
                                            <div>{{ iev_sideNum_Search.value.system_name }}</div>
                                        </div>
                                        <span v-else>
                                            {{ iev_sideNum_Search.placeholder }}
                                        </span>
                                    </template>
                                    <template #option="iev_sideNum_Search">
                                        <div>{{ iev_sideNum_Search.option.system_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>
                        </div>

                        <div class="p-formgrid p-grid" style="margin-left: 1px">
                            <!-- <div class="p-field p-col-12 p-lg-12 p-mt-2"> -->

                            <div class="p-field p-col-12 p-lg-3 p-mt-2">
                                <label for="ie_equipment_code">{{ 'หมายเลขอุปกรณ์' }}</label>
                                <InputText
                                    id="ie_equipment_code"
                                    type="text"
                                    v-model="ie_equipment_code"
                                    ref="TextBox_1_search"
                                    @keyup.left="moveFocus($event, 'TextBox_7_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_5_search', 'Input')"
                                />
                            </div>

                            <div class="p-field p-col-12 p-lg-3 p-mt-2">
                                <label for="ie_equipment_community">{{ 'ชุมชน' }}</label>
                                <Dropdown
                                    v-model="ie_equipment_community"
                                    :options="communityOptions"
                                    optionLabel="community_name"
                                    :dataKey="'community_id'"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <!-- Template for the selected value -->
                                    <template #value="slotProps">
                                        <div v-if="slotProps.value">
                                            <div>{{ slotProps.value.community_name }}</div>
                                        </div>
                                        <span v-else>
                                            {{ slotProps.placeholder }}
                                        </span>
                                    </template>
                                    <!-- Template for each option -->
                                    <template #option="slotProps">
                                        <div class="EV_communityOptions">
                                            {{ slotProps.option.community_name }}
                                        </div>
                                    </template>
                                </Dropdown>
                            </div>

                            <div class="p-field p-col-11 p-lg-5">
                                <label for="equipment_group">{{ $t('iev_equipment_standard_name') }}</label>
                                <!-- <Dropdown
                v-model="equipment_standard_name"
                :options="standard_nameOptions"
                optionLabel="system_name"
                :filter="true"
                :placeholder="$t('placeholderSelectBox')"
                :showClear="true"
                :clearFilterDropdown="dropdownClearFilerValue"
              >
                <template #value="standard_nameOptions">
                  <div v-if="standard_nameOptions.value">
                    <div>{{ standard_nameOptions.value.system_name }}</div>
                  </div>
                  <span v-else>
                    {{ standard_nameOptions.placeholder }}
                  </span>
                </template>
                <template #option="standard_nameOptions">
                  <div>{{ standard_nameOptions.option.system_name }}</div>
                </template>
              </Dropdown> -->
                                <MultiSelect
                                    v-model="equipment_standard_name"
                                    :options="standard_nameOptions"
                                    optionLabel="system_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    class="multiselect-custom"
                                    :clearFilterMultiSelect="multiSelectClearFilerValue"
                                >
                                    <template #value="slotProps">
                                        <div class="item item-value" v-for="option of slotProps.value" :key="option.id">
                                            <div>{{ option.system_name }}</div>
                                        </div>
                                        <template v-if="!slotProps.value || slotProps.value.length === 0">
                                            {{ $t('placeholderSelectBox') }}
                                        </template>
                                    </template>
                                    <template #option="slotProps">
                                        <div class="item">
                                            <div>{{ slotProps.option.system_name }}</div>
                                        </div>
                                    </template>
                                </MultiSelect>
                            </div>
                            <div class="p-field p-col-1 p-lg-1 p-mt-5">
                                <Button
                                    @click="
                                        equipment_standard_name = null;
                                        multiSelectClearFilerValue += 1;
                                    "
                                    icon="pi pi-times"
                                    class="p-button-danger p-mt-2"
                                />
                            </div>
                        </div>

                        <div class="p-field p-col">
                            <div class="p-formgrid p-grid">
                                <!-- <div class="p-field p-col-7 p-lg-4 p-mt-2">
                      <label for="organize">{{ $t("response_agency") }}</label>
                      <InputText
                        id="equipment_organize"
                        type="text"
                        v-model="selectedOrganize.name"
                        disabled
                      />
                    </div>
                    <div class="p-field p-lg-2" style="padding-top: 3.5px ;">
                      <Button
                        @click="showOrganize = true"
                        icon="pi pi-ellipsis-h"
                        class="p-button-secondary p-mt-5 p-mr-2"
                      />
                      <Button
                        @click="selectedOrganize = {}"
                        icon="pi pi-times"
                        class="p-button-danger p-mt-5"
                      />
                    </div> -->

                                <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                    <div class="p-field-checkbox p-col p-jc-start p-mt-5">
                                        <Checkbox id="update_info" name="update_info" value="1" v-model="update_info" />
                                        <label for="update_info">{{ $t('imp_update_info') }}</label>
                                    </div>
                                </div>
                                <div class="p-field p-col">
                                    <div class="p-formgrid p-grid p-jc-end p-mt-5">
                                        <!-- Doe โหลด โทรศัพท์ -->
                                        <Button
                                            v-if="window.width <= 430"
                                            @click="MobileClearSearchField()"
                                            :label="$t('clearBtn')"
                                            class="p-button-clear p-ml-3 p-mr-3"
                                            ref="TextBox_3_search"
                                            @keyup.left="moveFocus($event, 'TextBox_2_search', 'Input')"
                                            @keyup.right="moveFocus($event, 'TextBox_4_search', 'Button')"
                                            @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                        />
                                        <Button
                                            v-else
                                            @click="clearSearchField()"
                                            :label="$t('clearBtn')"
                                            class="p-button-clear p-ml-3 p-mr-3"
                                            ref="TextBox_3_search"
                                            @keyup.left="moveFocus($event, 'TextBox_2_search', 'Input')"
                                            @keyup.right="moveFocus($event, 'TextBox_4_search', 'Button')"
                                            @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                        />
                                        <!-- Doe โหลด โทรศัพท์ -->
                                        <!-- <Button
                          @click="searchEquipmentInfo()"
                          :label="$t('searchBtn')"
                          class="p-button-info"
                          ref="TextBox_4_search"
                          @keyup.left="moveFocus($event, 'TextBox_3_search','Button')"
                          @keyup.right="moveFocus($event, 'TextBox_1_search','Button')"
                          @keyup.up="moveFocus($event, 'TextBox_2_search','Input')"
                        /> -->
                                        <Button
                                            @click="fastSearchEquipmentInfo()"
                                            :label="$t('searchBtn')"
                                            class="p-button-info"
                                            ref="TextBox_4_search"
                                            @keyup.left="moveFocus($event, 'TextBox_3_search', 'Button')"
                                            @keyup.right="moveFocus($event, 'TextBox_1_search', 'Button')"
                                            @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="p-field p-col-4">
              <label for="equipment_type">{{ $t("iev_equipment_type") }}</label>
              <Dropdown
                :disabled="disabledEquiptype == 1"
                v-model="equipmentTypeSelected"
                :options="equipmentTypeOptions"
                optionLabel="system_name"
                :filter="true"
                :placeholder="$t('placeholderSelectBox')"
                :showClear="true"
              >
                <template #value="equipmentTypeOptions">
                  <div v-if="equipmentTypeOptions.value">
                    <div>{{ equipmentTypeOptions.value.system_name }}</div>
                  </div>
                  <span v-else>
                    {{ equipmentTypeOptions.placeholder }}
                  </span>
                </template>
                <template #option="equipmentTypeOptions">
                  <div>{{ equipmentTypeOptions.option.system_name }}</div>
                </template>
              </Dropdown>
            </div> -->
                    </div>
                </div>

                <div class="p-formgrid p-grid p-col p-mt-1">
                    <text-footer :data="Data_text_Footer" :checkShow="text_Footer" :countItem="equipmentInfo_Table.length.toLocaleString('en-US')" />
                </div>
            </div>
        </Fieldset>

        <Dialog :modal="true" :header="$t('OrganizeModalHeader')" :visible.sync="showOrganize" :style="{ width: '80%', overflow: 'auto' }">
            <organize-table
                @selectOrganization="selectedOrganize_passValue"
                :parentmessage="parentmessage_organize"
                :checkForm="checkSelectedOrganize(setOpenModal_OrganizeMulti)"
            ></organize-table>
        </Dialog>

        <Dialog :modal="true" :header="$t('OrganizeModalHeader')" :visible.sync="showOrganize_Form" :style="{ width: '80%', overflow: 'auto' }">
            <organize-form @selectOrganization="selectedOrganize_passValue_Form"></organize-form>
        </Dialog>

        <div class="card p-fluid p-mt-2">
            <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
            <!-- :scrollable="true" -->
            <DataTable
                :value="columns_disabled ? equipmentInfo_Table : []"
                :paginator="true"
                :rows="10"
                scrollHeight="500px"
                dataKey="id"
                :sortOrder="1"
                sortField="index"
                ref="dt"
                :exportFilename="`รายละเอียดข้อมูลสถานะของอุปกรณ์ยานพาหนะ (ชื่อมาตรฐาน)-${date}`"
                :rowHover="true"
                :selection.sync="selectedEquipmentInfo"
                :filters="filters"
                :loading="loading"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
            >
                <!-- Doe : เพิ่ม ลำดับ 1/4 จบ  sortField="index" :sortOrder="1" -->
                <template #header>
                    <div class="p-grid">
                        <!-- Doe : PDF 1/3 -->
                        <div class="table-header" style="padding: 7px" id="EX">
                            <Button @click="exportCSV()" :label="$t('exportBtn')" style="background-color: green" />
                        </div>
                        <div class="table-header" style="padding: 7px" id="PDF">
                            <SplitButton
                                label="ส่งออก PDF"
                                :model="items"
                                class="p-button-raised p-button-danger"
                                style="background-color: #f33737"
                            ></SplitButton>
                        </div>
                        <!-- Doe : PDF 1/3 จบ -->

                        <!-- Doe PDF เลือกได้  1/5   -->
                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px">
                            <Button
                                @click="EditPDF()"
                                icon="pi pi-cog"
                                :label="'ตั้งค่า'"
                                style="background-color: #0288d1; border: 1px solid #0288d1"
                            />
                        </div>

                        <div
                            class="table-header"
                            id="TABLE_EDIT"
                            style="padding: 7px"
                            v-if="selectedEquipmentInfo && selectedEquipmentInfo.length > 0"
                        >
                            <Button
                                @click="updateDates()"
                                icon="pi pi-cog"
                                :label="'ปรับปรุงข้อมูล'"
                                style="background-color: #fab12f; border: 1px solid #fab12f"
                            />
                        </div>

                        <!-- Doe PDF เลือกได้  1/5 จบ  -->

                        <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
                            <!-- <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span> -->

                            <!-- Doe ค้นหา  1/5 -->

                            <span class="p-input-icon-left" v-if="columns_disabled">
                                <i class="pi pi-search" />
                                <InputText v-model="filter" @input="search()" :placeholder="$t('searchHeader')" />
                            </span>
                            <span class="p-input-icon-left" v-else>
                                <i class="pi pi-search" />
                                <InputText disabled v-model="filter" @input="search()" :placeholder="$t('searchHeader')" />
                            </span>

                            <!-- Doe ค้นหา  1/5 จบ-->
                        </div>
                    </div>
                </template>

                <template #empty>{{ $t('TableEmpty') }}</template>

                <!--Doe : เพิ่มลำดับ 2/4-->
                <!-- :headerStyle="{width: '8rem',textAlign:'center',position:'sticky',top:'0'}" -->
                <div v-if="columns_index == true">
                    <Column field="index" :header="'ลำดับ'" :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_index == true">
                                {{ dataTable.data.index }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>
                <!--Doe : เพิ่มลำดับ 2/4 จบ-->

                <!-- เพิ่ม coloums ชื่อเครื่องมือฯ (ชื่อมาตรฐาน) จบ -->

                <div v-if="columns_ev_organize_name == true">
                    <Column field="organize_name" :header="$t('imp_organize')" :headerStyle="tableColSticky('250px', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_ev_organize_name == true" style="text-center">
                                {{
                                    dataTable.data.organize_name == 'null' ||
                                    dataTable.data.organize_name == null ||
                                    dataTable.data.organize_name == ''
                                        ? '-'
                                        : dataTable.data.organize_name
                                }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <!-- <div v-if="columns_ev_standard_name == true">
                    <Column
                        field="standard_name"
                        :header="$t('iev_equipment_standard_name')"
                        :headerStyle="tableColSticky('250px', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_ev_standard_name == true" style="text-center">
                                {{
                                    dataTable.data.standard_name == 'null' ||
                                    dataTable.data.standard_name == null ||
                                    dataTable.data.standard_name == ''
                                        ? '-'
                                        : dataTable.data.standard_name
                                }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div> -->

                <div v-if="columns_status1 == true">
                    <Column field="status1" :header="$t('พร้อมใช้')" :headerStyle="tableColSticky('150px', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_status1 == true">
                                {{ Number(dataTable.data.status1).toLocaleString('en-US') }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_status2 == true">
                    <Column field="status2" :header="$t('ซ่อม')" :headerStyle="tableColSticky('200px', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_status2 == true">
                                {{ Number(dataTable.data.status2).toLocaleString('en-US') }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_status3 == true">
                    <Column field="status3" :header="$t('ชำรุด')" :headerStyle="tableColSticky('180px', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_status3 == true">
                                {{ Number(dataTable.data.status3).toLocaleString('en-US') }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_status4 == true">
                    <Column field="status4" :header="$t('รอจำหน่าย')" :headerStyle="tableColSticky('180px', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_status4 == true">
                                {{ Number(dataTable.data.status4).toLocaleString('en-US') }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_status5 == true">
                    <Column field="status5" :header="$t('จำหน่าย')" :headerStyle="tableColSticky('240px', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_status5 == true">
                                {{ Number(dataTable.data.status5).toLocaleString('en-US') }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_status6 == true">
                    <Column field="status6" :header="$t('อุปกรณ์ชำรุด')" :headerStyle="tableColSticky('180px', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_status6 == true">
                                <div>{{ Number(dataTable.data.status6).toLocaleString('en-US') }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_total == true">
                    <Column field="total" :header="$t('ผลรวมทั้งหมด')" :headerStyle="tableColSticky('180px', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_total == true">
                                <div>{{ Number(dataTable.data.total).toLocaleString('en-US') }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>
            </DataTable>
        </div>
        <!-- v-if="loadingCreate" -->

        <!-- Manage data -->
        <Dialog
            :modal="true"
            :visible.sync="equipmentInfoModal"
            :style="{ width: '85%' }"
            :contentStyle="{ 'overflow-y': 'scroll' }"
            :closable="loadingCreate ? false : true"
            :header="header"
        >
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Modal_Main')">
                <!-- โหลดเพิ่มแก้ไข 1/8-->
                <div class="From_Loading" v-if="loadingCreate">
                    <ProgressSpinner style="width: 120px; height: 120px; color: red" strokeWidth="5" animationDuration="1s" />
                    <div class="waveTextAnimated">
                        <span>กำ</span>
                        <span>ลัง</span>
                        <span>บัน</span>
                        <span>ทึก</span>
                        <span>ข้อ</span>
                        <span>มูล</span>
                    </div>
                </div>
                <!-- โหลดเพิ่มแก้ไข 1/8 จบ-->
                <label>{{ $t('iev_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-5">
                    <div class="p-grid">
                        <!-- ส่วนชื่อเครื่องมือ -->

                        <div class="p-field p-col-12 p-lg-3">
                            <label for="iev_equipment_name">{{ $t('iev_equipment_name') }} <span class="required-input">*</span></label>
                            <InputText
                                id="iev_equipment_name"
                                type="text"
                                v-model="iev_equipment_name"
                                autofocus
                                required="true"
                                :class="{
                                    'p-invalid': error_iev_equipment_name && !iev_equipment_name
                                }"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_20', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_7', 'Input')"
                            />
                            <!-- @keyup.right="moveFocus($event, 'TextBox_2','InputNumber')" -->
                            <small class="p-invalid" v-if="error_iev_equipment_name && !iev_equipment_name">{{
                                $t('iev_equipment_name_validate')
                            }}</small>
                        </div>
                        <!-- / -->
                        <!-- ส่วนชื่อมาตราฐาน -->
                        <div class="p-field p-col-12 p-lg-3">
                            <label for="iev_equipment_standard_name"
                                >{{ $t('iev_equipment_standard_name') }}
                                <span class="required-input">*</span>
                            </label>
                            <Dropdown
                                v-model="iev_equipment_standard_name"
                                :options="standard_nameOptions"
                                optionLabel="system_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                @change="genCodeId"
                                :class="{
                                    'p-invalid': error_iev_equipment_standard_name === true
                                }"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="standard_nameOptions">
                                    <div v-if="standard_nameOptions.value">
                                        <div
                                            v-if="
                                                standard_nameOptions.value.system_name !== null && standard_nameOptions.value.system_name !== 'null'
                                            "
                                        >
                                            <div>{{ standard_nameOptions.value.system_name }}</div>
                                        </div>
                                        <span v-else>
                                            {{ standard_nameOptions.placeholder }}
                                        </span>
                                    </div>
                                    <span v-else>
                                        {{ standard_nameOptions.placeholder }}
                                    </span>
                                </template>
                                <template #option="standard_nameOptions">
                                    <div class="EV_disasterOptions">{{ standard_nameOptions.option.system_name }}</div>
                                </template>
                            </Dropdown>
                            <div>
                                <!-- <div>{{ error_iev_equipment_standard_name }}</div> -->
                                <!-- <small
                        class="p-invalid"
                        v-if="error_iev_equipment_standard_name && !iev_equipment_standard_name"
                        >{{ $t("iev_equipment_standard_name_validate") }}</small
                      > -->
                                <small class="p-invalid" v-if="error_iev_equipment_standard_name === true">{{
                                    $t('iev_equipment_standard_name_validate')
                                }}</small>
                            </div>
                        </div>

                        <div class="p-field p-col-8 p-lg-2">
                            <label for="ira_location_name">{{ 'หมายเลขอุปกรณ์' }} <span class="required-input">*</span></label>
                            <InputText id="equipment_code" type="text" disabled v-model="equipment_code" />
                        </div>

                        <!-- / -->
                        <!-- ส่วนหน่วยงานที่รับผิดชอบ -->
                        <!-- <div class="p-formgrid p-grid p-mt-2" > -->
                        <div class="p-field p-col-8 p-lg-3">
                            <label for="iev_organize">{{ $t('response_agency') }} <span class="required-input">*</span></label>
                            <InputText
                                id="iev_organize"
                                type="text"
                                v-model="iev_organize.name"
                                disabled
                                :class="{
                                    'p-invalid': error_iev_organize && !iev_organize.name
                                }"
                            />
                            <small class="p-invalid" v-if="error_iev_organize && !iev_organize.name">{{ $t('iev_organize_validate') }}</small>
                        </div>

                        <div class="p-field" style="padding-top: 7px">
                            <div>
                                <Button
                                    ref="TextBox_2"
                                    @keyup.left="moveFocus($event, 'TextBox_1', 'Input')"
                                    @keyup.right="moveFocus($event, 'TextBox_3', 'Button')"
                                    @keyup.down="moveFocus($event, 'TextBox_5', 'Button')"
                                    @click="showOrganize_Form = true"
                                    icon="pi pi-ellipsis-h"
                                    class="p-button-secondary p-mt-5 p-mr-2"
                                />
                                <Button
                                    ref="TextBox_3"
                                    @keyup.left="moveFocus($event, 'TextBox_2', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_4', 'InputNumber')"
                                    @keyup.down="moveFocus($event, 'TextBox_6', 'Button')"
                                    @click="iev_organize = {}"
                                    icon="pi pi-times"
                                    class="p-button-danger p-mt-5"
                                />
                            </div>
                        </div>
                        <!-- </div> -->
                        <!-- / -->

                        <!-- กลุ่มเครื่องมือฯ * -->
                        <div class="p-field p-col-12 p-lg-3">
                            <label for="equipment_group">{{ $t('iev_equipment_group') }} <span class="required-input">*</span></label>
                            <Dropdown
                                v-model="iev_equipment_group"
                                @change="someHandler"
                                optionLabel="system_name"
                                :options="equipmentGroupOptions"
                                :class="{
                                    'p-invalid': error_iev_equipment_group && !iev_equipment_group
                                }"
                                :placeholder="$t('placeholderSelectBox')"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="equipmentGroupOptions">
                                    <div v-if="equipmentGroupOptions.value">
                                        <div>{{ equipmentGroupOptions.value.system_name }}</div>
                                    </div>
                                </template>
                                <template #option="equipmentGroupOptions">
                                    <div>{{ equipmentGroupOptions.option.system_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_iev_equipment_group && !iev_equipment_group">{{
                                $t('iev_equipment_group_validate')
                            }}</small>
                        </div>
                        <!-- / -->
                        <!-- ประเภทเครื่องมือฯ * -->
                        <div class="p-field p-col-12 p-lg-3">
                            <label for="equipment_type">{{ $t('iev_equipment_type') }} <span class="required-input">*</span></label>
                            <Dropdown
                                v-model="iev_equipment_type"
                                :options="equipmentTypeOptions"
                                :class="{
                                    'p-invalid': error_iev_equipment_type && !iev_equipment_type
                                }"
                                optionLabel="system_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="equipmentTypeOptions">
                                    <div v-if="equipmentTypeOptions.value">
                                        <div>{{ equipmentTypeOptions.value.system_name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ equipmentTypeOptions.placeholder }}
                                    </span>
                                </template>
                                <template #option="equipmentTypeOptions">
                                    <div>{{ equipmentTypeOptions.option.system_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_iev_equipment_type && !iev_equipment_type">{{
                                $t('iev_equipment_type_validate')
                            }}</small>
                        </div>
                        <!--  -->

                        <!-- / -->
                        <!-- ส่วนจำนวน -->
                        <div class="p-field p-col-12 p-lg-2 p-mt-1">
                            <label for="iev_equipment_amount">{{ 'จำนวน' }}</label>
                            <InputNumber
                                id="iev_equipment_amount"
                                type="text"
                                v-model="iev_equipment_amount"
                                :min="0"
                                autofocus
                                ref="TextBox_4"
                                @keyup.left="moveFocus($event, 'TextBox_3', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_5', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_2', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_8', 'Input')"
                            />
                        </div>

                        <!-- ส่วนรูปภาพ -->
                        <div class="p-col-12 p-lg-4 p-mt-5">
                            <span hidden>{{ url }}</span>
                            <div class="p-grid">
                                <div class="p-col-8 p-lg-8">
                                    <Button
                                        @click="onFileChange"
                                        class="p-button-success"
                                        icon="pi pi-plus"
                                        label="เลือกไฟล์ภาพ"
                                        ref="TextBox_5"
                                        @keyup.left="moveFocus($event, 'TextBox_4', 'InputNumber')"
                                        @keyup.right="moveFocus($event, 'TextBox_6', 'Button')"
                                        @keyup.up="moveFocus($event, 'TextBox_2', 'Button')"
                                        @keyup.down="moveFocus($event, 'TextBox_8', 'Input')"
                                    >
                                    </Button>

                                    <input
                                        ref="file"
                                        style="visibility: hidden; display: none; text-overflow: ellipsis"
                                        type="file"
                                        id="iev_uploadImageFile"
                                        @change="onFileChange"
                                        class="inputzone"
                                        accept="image/*"
                                    />
                                    <!-- <button style="  @click="onFileChange">Choose</button> -->
                                </div>
                                <div class="p-col-4 p-lg-4">
                                    <Button
                                        @click="clearImage()"
                                        icon="pi pi-times"
                                        class="p-button-danger"
                                        style="width: auto"
                                        :label="$t('clearImage')"
                                        ref="TextBox_6"
                                        @keyup.left="moveFocus($event, 'TextBox_5', 'Button')"
                                        @keyup.right="moveFocus($event, 'TextBox_7', 'Input')"
                                        @keyup.up="moveFocus($event, 'TextBox_3', 'Button')"
                                        @keyup.down="moveFocus($event, 'TextBox_9', 'Input')"
                                    />
                                </div>
                            </div>
                            <!-- <div id="preview"> {{ pic }} </div> -->
                            <div id="preview">
                                <img v-if="url" :src="url" />
                            </div>
                            <div id="iev_image" ref="iev_image" hidden></div>
                        </div>
                    </div>
                    <!-- / -->

                    <div class="p-formgrid p-grid p-col-12 p-lg-12">
                        <div class="p-field p-col-12 p-lg-3">
                            <label for="iev_equipment_number">
                                {{ $t('iev_equipment_number') }}
                            </label>

                            <InputText
                                id="iev_equipment_number"
                                type="text"
                                v-model="iev_equipment_number"
                                autofocus
                                @input="acceptNumberEquipmentNumber()"
                                placeholder="xxxx-xxxxxxxx-xxxxxxxx-xxxxx"
                                ref="TextBox_7"
                                @keyup.left="moveFocus($event, 'TextBox_6', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_12', 'Input')"
                                :class="{
                                    'p-invalid': error_iev_equipment_number && !iev_equipment_number
                                }"
                            />
                            <!-- <InputMask
                                mask="9999-99999999-99999999-99999"
                                placeholder="xxxx-xxxxxxxx-xxxxxxxx-xxxxx"
                                id="iev_equipment_number"
                                :autoClear="false"
                                v-model="iev_equipment_number"
                                ref="TextBox_7"
                                @keyup.left="moveFocus($event, 'TextBox_6', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_12', 'Input')"
                                autofocus
                                :class="{
                                    'p-invalid': error_iev_equipment_number && !iev_equipment_number
                                }"
                            /> -->
                            <small class="p-invalid" v-if="error_iev_equipment_number && !iev_equipment_number">{{
                                $t('vidatetionerror_iev_equipment_number')
                            }}</small>
                        </div>
                        <div class="p-field p-col-12 p-lg-3">
                            <label for="iev_equipment_status">{{ $t('iev_equipment_status') }}</label>

                            <Dropdown
                                v-model="iev_equipment_status"
                                optionLabel="name"
                                :options="equipmentStatusOptions"
                                :placeholder="$t('placeholderSelectBox')"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="equipmentStatusOptions">
                                    <div v-if="equipmentStatusOptions.value">
                                        <div>{{ equipmentStatusOptions.value.name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ equipmentStatusOptions.placeholder }}
                                    </span>
                                </template>
                                <template #option="equipmentStatusOptions">
                                    <div>{{ equipmentStatusOptions.option.name }}</div>
                                </template>
                            </Dropdown>
                        </div>
                        <div class="p-field p-col-12 p-lg-3">
                            <label for="iev_license_car">{{ $t('iev_license_car') }}</label>
                            <InputText
                                id="iev_license_car"
                                type="text"
                                v-model="iev_license_car"
                                autofocus
                                ref="TextBox_8"
                                @keyup.left="moveFocus($event, 'TextBox_7', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_4', 'InputNumber')"
                                @keyup.down="moveFocus($event, 'TextBox_10', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-12 p-lg-3">
                            <label for="iev_sidecar_number">{{ $t('iev_sidecar_number') }}</label>
                            <InputText
                                id="iev_sidecar_number"
                                type="text"
                                v-model="iev_sidecar_number"
                                autofocus
                                ref="TextBox_9"
                                @keyup.left="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_5', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_11', 'Input')"
                            />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12 p-lg-12">
                        <!-- Add textbox for car-brand and received date -->
                        <div class="p-field p-col-12 p-lg-3">
                            <label for="iev_car_brand">{{ $t('iev_car_brand') }}</label>
                            <Dropdown
                                v-model="iev_car_brand"
                                :options="brands"
                                optionLabel="system_name"
                                :filter="true"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                                :placeholder="$t('placeholderSelectBox')"
                                style="height: 33px"
                            >
                                <template #value="brands">
                                    <div v-if="brands.value">
                                        <div>{{ brands.value.system_name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ brands.placeholder }}
                                    </span>
                                </template>
                                <template #option="brands">
                                    <div>{{ brands.option.system_name }}</div>
                                </template>
                            </Dropdown>
                        </div>
                        <div class="p-field p-col-12 p-lg-3">
                            <label for="iev_received_date">วันที่ได้รับ</label>
                            <Calendar
                                dateFormat="dd/mm/yy"
                                :maxDate="date_yearRange"
                                :manualInput="true"
                                :showButtonBar="true"
                                :monthNavigator="true"
                                :yearNavigator="true"
                                :yearRange="`2000:${setYearRange(date_yearRange, 0, 'plus')}`"
                                :locale="th"
                                v-model="iev_received_date"
                                :appendTo="'body'"
                            >
                            </Calendar>
                        </div>
                        <div class="p-field p-col-12 p-lg-2">
                            <label for="iev_received_date">ละติจูด (Y)</label>
                            <InputText
                                id="iev_equipment_lat"
                                type="text"
                                v-model="iev_equipment_lat"
                                :placeholder="!iev_equipment_lat ? '-' : ''"
                                autofocus
                                required="true"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_20', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_7', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-12 p-lg-2">
                            <label for="iev_received_date">ลองจิจูด (X)</label>
                            <InputText
                                id="iev_equipment_lon"
                                type="text"
                                v-model="iev_equipment_lon"
                                :placeholder="!iev_equipment_lon ? '-' : ''"
                                autofocus
                                required="true"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_20', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_7', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-12 p-lg-2">
                            <label for="equipment_community">ชุมชน</label>
                            <Dropdown
                                v-model="equipment_community"
                                :options="communityOptions"
                                optionLabel="community_name"
                                :dataKey="'community_id'"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <!-- Template for the selected value -->
                                <template #value="slotProps">
                                    <div v-if="slotProps.value">
                                        <div>{{ slotProps.value.community_name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ slotProps.placeholder }}
                                    </span>
                                </template>
                                <!-- Template for each option -->
                                <template #option="slotProps">
                                    <div class="EV_communityOptions">
                                        {{ slotProps.option.community_name }}
                                    </div>
                                </template>
                            </Dropdown>
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-2">
                            <label for="date_create_form">วันที่สร้างข้อมูล <span class="required-input"> </span></label>
                            <InputText id="date_create_form" type="text" v-model="date_create_form" autofocus disabled />
                        </div>
                        <div class="p-field p-col-12 p-lg-2">
                            <label for="date_update_form">{{ $t('imp_update_info_date') }}<span class="required-input"> </span></label>
                            <InputText id="date_update_form" type="text" v-model="date_update_form" autofocus disabled />
                        </div>
                        <!-- <div class="p-field p-col-12 p-lg-2">
              <label for="iev_update_info_date">{{
                $t("imp_update_info_date")
              }}</label>
              <InputText
                id="iev_update_info_date"
                type="text"
                v-model="iev_update_info_date"
                autofocus
                disabled
              />
            </div> -->
                        <div class="p-field p-col-12 p-lg-4">
                            <label for="iev_response_contact_name">{{ $t('iev_response_contact_name') + ' (สังกัด)' }}</label>
                            <InputText
                                id="iev_response_contact_name"
                                type="text"
                                v-model="iev_response_contact_name"
                                autofocus
                                ref="TextBox_10"
                                @keyup.left="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_11', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_13', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-12 p-lg-4">
                            <label for="iev_position">{{ $t('imp_position') }}</label>
                            <InputText
                                id="iev_position"
                                type="text"
                                v-model="iev_position"
                                autofocus
                                ref="TextBox_11"
                                @keyup.left="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_12', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.down="
                                    moveFocus($event, contact_phone_office && contact_phone_office !== '-' ? 'TextBox_14' : 'TextBox_15', 'Input')
                                "
                            />
                        </div>

                        <!-- <div class="p-field p-col-12 p-lg-3">
              <label for="iev_contact_phone">{{ $t("contact_phone") }}</label>
              <InputText
                id="iev_contact_phone"
                type="text"
                v-model="iev_contact_phone"
                @input="acceptNumberPhone"
                autofocus
              />
            </div> -->

                        <!-- <div class="p-field p-col-12 p-lg-3">
              <label for="iev_contact_phone">{{ $t("contact_phone") }}</label>
              <InputText
                id="iev_contact_phone"
                type="text"
                v-model="iev_contact_phone"
                
                autofocus
              />
            </div> -->
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-5">
                            <label for="contact_phone">เบอร์โทรศัพท์ผู้ติดต่อ (โทรศัพท์มือถือ)</label>
                            <InputText
                                type="text"
                                v-model="contact_phone"
                                @input="acceptNumberPhone"
                                autofocus
                                :class="{
                                    'p-invalid': error_contact_phone && contact_phone.length !== 12
                                }"
                                ref="TextBox_12"
                                @keyup.left="moveFocus($event, 'TextBox_11', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_13', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_15', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_contact_phone && contact_phone.length !== 12"
                                >กรุณาระบุเบอร์โทรศัพท์ผู้ติดต่อ (โทรศัพท์มือถือ) 10 หลัก</small
                            >
                        </div>
                        <div class="p-field p-col-12 p-lg-4">
                            <label for="contact_phone_office">เบอร์โทรศัพท์ผู้ติดต่อ (สำนักงาน)</label>
                            <InputText
                                id="contact_phone_office"
                                type="text"
                                v-model="contact_phone_office"
                                @input="acceptNumberPhone2"
                                autofocus
                                :class="{
                                    'p-invalid': error_contact_phone_office && contact_phone_office.length !== 11
                                }"
                                ref="TextBox_13"
                                @keyup.left="moveFocus($event, 'TextBox_12', 'Input')"
                                @keyup.right="
                                    moveFocus($event, contact_phone_office && contact_phone_office !== '-' ? 'TextBox_14' : 'TextBox_15', 'Input')
                                "
                                @keyup.up="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_15', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_contact_phone_office && contact_phone_office.length !== 11"
                                >กรุณาระบุเบอร์โทรศัพท์ผู้ติดต่อ (สำนักงาน) 9 หลัก</small
                            >
                        </div>

                        <div class="p-field p-col-12 p-lg-3" v-if="contact_phone_office && contact_phone_office !== '-'">
                            <label for="iev_contact_phone">ext. (ต่อเบอร์ภายใน)</label>
                            <InputText
                                id="contact_phone_office_ext"
                                type="text"
                                v-model="contact_phone_office_ext"
                                @input="acceptNumberPhone3"
                                autofocus
                                ref="TextBox_14"
                                @keyup.left="moveFocus($event, 'TextBox_13', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_15', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_11', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_15', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-12 p-lg-3" v-else>
                            <label for="iev_contact_phone">ext. (ต่อเบอร์ภายใน)</label>
                            <InputText
                                disabled
                                id="contact_phone_office_ext"
                                type="text"
                                v-model="contact_phone_office_ext"
                                @input="acceptNumberPhone3"
                                placeholder="กรุณาระบุเบอร์โทรศัพท์ผู้ติดต่อ (สำนักงาน)"
                                autofocus
                                ref="TextBox_14"
                                @keyup.left="moveFocus($event, 'TextBox_13', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_15', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_11', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_15', 'Input')"
                            />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col">
                            <label for="iev_detail">{{ $t('imp_detail') }}</label>

                            <div v-if="iev_equipment_status.id == '5'">
                                <label>{{ 'หมายเหตุ : โปรดระบุรายละเอียดเพิ่มเติมสำหรับการจำหน่าย' }}</label>
                            </div>
                            <div v-else>
                                <label>{{ '' }}</label>
                            </div>

                            <Textarea
                                id="iev_detail"
                                type="text"
                                v-model="iev_detail"
                                autofocus
                                ref="TextBox_15"
                                @keyup.left="
                                    moveFocus($event, contact_phone_office && contact_phone_office !== '-' ? 'TextBox_14' : 'TextBox_13', 'Input')
                                "
                                @keyup.right="moveFocus($event, showDeviceOfVehicle ? 'TextBox_16' : 'TextBox_17', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_12', 'Input')"
                                @keyup.down="moveFocus($event, showDeviceOfVehicle ? 'TextBox_16' : 'TextBox_17', 'Input')"
                            />
                        </div>
                    </div>
                    <div class="p-field-checkbox p-col-12 p-justify-end">
                        <Checkbox id="iev_update_info" name="iev_update_info" value="1" v-model="iev_update_info" />
                        <label for="iev_update_info">{{ $t('imp_update_info') }}</label>
                    </div>

                    <hr />
                    <!-- อุปกรณ์ประจำยานพาหนะ -->
                    <div v-if="showDeviceOfVehicle">
                        <div class="p-formgrid p-grid p-col-12">
                            <div class="p-field p-col-10">
                                <label>{{ $t('iev_deviceOfVehicle') }}</label>
                            </div>
                            <div class="p-field p-col-6 p-lg-2">
                                <Button
                                    @click="addDeviceOfVehicleModal = true"
                                    icon="pi pi-plus"
                                    :label="$t('addBtn')"
                                    class="p-button-success"
                                    ref="TextBox_16"
                                    @keyup.left="moveFocus($event, 'TextBox_15', 'Input')"
                                    @keyup.right="moveFocus($event, 'TextBox_17', 'Button')"
                                    @keyup.up="moveFocus($event, 'TextBox_15', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_17', 'Button')"
                                />
                            </div>
                        </div>
                        <div class="p-formgrid p-grid p-col-12">
                            <div class="p-field p-col-12">
                                <DataTable
                                    :value="deviceOfVehicle_table"
                                    :scrollable="true"
                                    scrollHeight="500px"
                                    :paginator="true"
                                    :rows="5"
                                    :rowHover="true"
                                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                    :rowsPerPageOptions="[5, 10, 20, 50]"
                                    currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                                >
                                    <template #empty>{{ $t('TableEmpty') }}</template>
                                    <Column field="device_name" :header="$t('iev_deviceOfVehicle_name')" :sortable="true" headerStyle="width: 15rem">
                                        <template #body="dataTable">
                                            {{ dataTable.data.device_name }}
                                        </template>
                                    </Column>
                                    <Column field="size" :header="$t('iev_deviceOfVehicle_size')" :sortable="true" headerStyle="width: 15rem">
                                        <template #body="dataTable">
                                            {{ dataTable.data.size }}
                                        </template>
                                    </Column>
                                    <Column field="amount" :header="'จำนวนอุปกรณ์ประจำยานพาหนะ'" :sortable="true" headerStyle="width: 15rem">
                                        <template #body="dataTable">
                                            {{ dataTable.data.amount }}
                                        </template>
                                    </Column>
                                    <Column field="unit" :header="$t('iev_deviceOfVehicle_unit')" :sortable="true" headerStyle="width: 15rem">
                                        <template #body="dataTable">
                                            {{ dataTable.data.unit }}
                                        </template>
                                    </Column>
                                    <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                                        <template #body="dataTable">
                                            <div class="p-formgrid p-grid">
                                                <div class="p-field p-col-6">
                                                    <Button
                                                        @click="
                                                            // displayConfirmation = true;
                                                            deleteDevice = dataTable.data;
                                                            deleteAt = 'device-table';
                                                            alertDisplay(deleteDevice, deleteAt);
                                                        "
                                                        icon="pi pi-trash"
                                                        :label="$t('deleteBtn')"
                                                        class="p-button-rounded p-button-danger"
                                                    />
                                                </div>
                                            </div>
                                        </template>
                                    </Column>
                                </DataTable>
                            </div>
                        </div>
                    </div>

                    <hr />
                    <!-- ประวัติการซ่อมบำรุง -->
                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-10">
                            <label>{{ $t('iev_historyOfMaintenance') }}</label>
                        </div>
                        <div class="p-field p-col-6 p-lg-2">
                            <Button
                                @click="addMaintenanceHistoryModal = true"
                                icon="pi pi-plus"
                                :label="$t('addBtn')"
                                class="p-button-success"
                                ref="TextBox_17"
                                @keyup.left="
                                    moveFocus($event, showDeviceOfVehicle ? 'TextBox_16' : 'TextBox_15', showDeviceOfVehicle ? 'Button' : 'Input')
                                "
                                @keyup.right="moveFocus($event, 'TextBox_18', 'Button')"
                                @keyup.up="
                                    moveFocus($event, showDeviceOfVehicle ? 'TextBox_16' : 'TextBox_15', showDeviceOfVehicle ? 'Button' : 'Input')
                                "
                                @keyup.down="moveFocus($event, 'TextBox_18', 'Button')"
                            />
                        </div>
                    </div>
                    <!-- ตารางการซ่อม -->
                    <!-- <div class="p-formgrid p-grid p-col-12">
            <div class="p-field p-col-12">
              <DataTable
                :value="historyOfMaintenance_table"
                :scrollable="true"
                scrollHeight="500px"
                :paginator="true"
                :rows="5"
                :rowHover="true"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[5, 10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
              >
                <template #empty>{{ $t("TableEmpty") }}</template>
                <Column
                  field="startdate"
                  :header="$t('iev_historyOfMaintenance_startdate')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.startdate }}
                  </template>
                </Column>
                <Column
                  field="enddate"
                  :header="$t('iev_historyOfMaintenance_enddate')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.enddate }}
                  </template>
                </Column>
                <Column
                  field="detail"
                  :header="$t('iev_historyOfMaintenance_detail')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.detail }}
                  </template>
                </Column>
                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                  <template #body="dataTable">
                    <div class="p-formgrid p-grid">
                      <div class="p-field p-col-6">
                        <Button
                          @click="
                            // displayConfirmation = true;
                            deleteHistory = dataTable.data;
                            deleteAt = 'history-table';
                            alertDisplay(deleteHistory,deleteAt)
                          "
                          icon="pi pi-trash"
                          :label="$t('deleteBtn')"
                          class="p-button-rounded p-button-danger"
                        />
                      </div>
                    </div>
                  </template>
                </Column>
              </DataTable>
            </div>
          </div> -->

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12">
                            <DataTable
                                :value="MaintenanceHistory"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="5"
                                :rowHover="true"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                :rowsPerPageOptions="[5, 10, 20, 50]"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="name" :header="'ชื่อเจ้าหน้าที่'" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.name == null || dataTable.data.name == '' ? '-' : dataTable.data.name }}
                                    </template>
                                </Column>
                                <Column field="tel" :header="'โทรศัพท์ผู้ติดต่อ'" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.tel == null || dataTable.data.tel == '' ? '-' : dataTable.data.tel }}
                                    </template>
                                </Column>
                                <Column field="detail" :header="$t('iev_historyOfMaintenance_detail')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div
                                            v-if="
                                                dataTable.data.detail == null ||
                                                dataTable.data.detail == '' ||
                                                dataTable.data.detail == [] ||
                                                dataTable.data.detail_text == []
                                            "
                                        >
                                            -
                                        </div>
                                        <div v-else>
                                            <!-- <span v-html="change_TextDetail(dataTable.data.detail_text)"></span> -->
                                            <span v-html="dataTable.data.detail_text"></span>
                                        </div>
                                    </template>
                                </Column>

                                <Column :header="$t('controlTable')" headerStyle="width: 15rem;text-align: center">
                                    <template #body="dataTable">
                                        <div class="p-formgrid p-grid">
                                            <div class="p-col-6">
                                                <Button
                                                    @click="
                                                        addMaintenanceHistoryModal = true;
                                                        editDataMaintenance(dataTable.data.id_report);
                                                    "
                                                    icon="pi pi-pencil"
                                                    :label="'แก้ไข'"
                                                    class="p-button-rounded p-button-warning"
                                                />
                                            </div>
                                            <div class="p-col-6">
                                                <Button
                                                    @click="
                                                        // displayConfirmation = true;
                                                        deleteHistory = dataTable.data;
                                                        deleteAt = 'history-table';

                                                        alertDisplay(deleteHistory, deleteAt);
                                                    "
                                                    icon="pi pi-trash"
                                                    :label="$t('deleteBtn')"
                                                    class="p-button-rounded p-button-danger"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                                <!-- <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                  <template #body="dataTable">
                    <div class="p-formgrid p-grid">
                      <div class="p-field p-col-6">
                          <Button
                            @click="
                              // displayConfirmation = true;
                              deleteHistory = dataTable.data;
                              deleteAt = 'history-table';
                              alertDisplay(deleteHistory,deleteAt)
                            "
                            icon="pi pi-trash"
                            :label="$t('deleteBtn')"
                            class="p-button-rounded p-button-danger"
                          />
                        
                      </div>

                    </div>
                    
                  </template>
                </Column> -->
                            </DataTable>
                        </div>
                    </div>

                    <hr />
                    <!-- ประวัติการยืม -->
                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-10">
                            <label>{{ $t('iev_historyOfBorrowing') }}</label>
                        </div>
                        <div class="p-field p-col-6 p-lg-2">
                            <Button
                                @click="addBorrowingHistoryModal = true"
                                icon="pi pi-plus"
                                :label="$t('addBtn')"
                                class="p-button-success"
                                ref="TextBox_18"
                                @keyup.left="moveFocus($event, 'TextBox_17', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_19', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_17', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_19', 'Button')"
                            />
                        </div>
                    </div>
                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12">
                            <DataTable
                                :value="ev_borrowing_history"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="5"
                                :rowHover="true"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                :rowsPerPageOptions="[5, 10, 20, 50]"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column
                                    field="startdate"
                                    :header="$t('iev_historyOfBorrowing_startdate')"
                                    :sortable="true"
                                    headerStyle="width: 15rem"
                                >
                                    <template #body="dataTable">
                                        {{ dataTable.data.startdate }}
                                    </template>
                                </Column>
                                <Column field="enddate" :header="$t('iev_historyOfBorrowing_enddate')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.enddate }}
                                    </template>
                                </Column>
                                <Column field="detail" :header="$t('iev_historyOfBorrowing_detail')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.detail }}
                                    </template>
                                </Column>
                                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div class="p-formgrid p-grid">
                                            <div class="p-field p-col-6">
                                                <Button
                                                    @click="
                                                        // displayConfirmation = true;
                                                        deleteHistoryBorrowing = dataTable.data;
                                                        deleteAt = 'history-Borrowing-table';
                                                        alertDisplay(deleteHistoryBorrowing, deleteAt);
                                                    "
                                                    icon="pi pi-trash"
                                                    :label="$t('deleteBtn')"
                                                    class="p-button-rounded p-button-danger"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <!-- โหลดเพิ่มแก้ไข 2/8-->
                <Button
                    v-if="selectedData != ''"
                    :label="$t('cancelBtn')"
                    icon="pi pi-times"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_19"
                    @keyup.left="moveFocus($event, 'TextBox_18', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_20', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_18', 'Button')"
                />
                <Button
                    v-else
                    :label="$t('clearBtn')"
                    icon="pi pi-times"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_19"
                    @keyup.left="moveFocus($event, 'TextBox_18', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_20', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_18', 'Button')"
                />
                <Button
                    :label="$t('saveBtn')"
                    :disabled="loadingCreate ? true : false"
                    icon="pi pi-check"
                    class="p-button-text"
                    @click="saveData()"
                    ref="TextBox_20"
                    @keyup.left="moveFocus($event, 'TextBox_19', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_18', 'Button')"
                />
                <!-- โหลดเพิ่มแก้ไข 2/8 จบ-->
            </template>
        </Dialog>

        <Dialog :modal="true" :header="$t('ConfirmDelete')" :visible.sync="displayConfirmation" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <i class="pi pi-exclamation-triangle p-mr-3 p-mt2" style="font-size: 2rem" />
                <span>{{ $t('ConfirmDeleteSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="confirmDelete(temp)" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <!-- เพิ่มข้อมูลอุปกรณ์ประจำยานพาหนะ -->
        <Dialog :modal="true" :visible.sync="addDeviceOfVehicleModal" :style="{ width: '400px' }" :header="header_deviceOfVehicle">
            <div class="confirmation-content" @keyup.enter="saveData_Modal('addDevice')">
                <label>{{ $t('ide_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-3">
                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col">
                            <label for="device_type">{{ $t('iev_deviceOfVehicle_type') }} <span class="required-input">*</span></label>
                            <Dropdown
                                v-model="iev_deviceOfVehicle_type"
                                @change="someHandler2"
                                :options="deviceTypeOptions"
                                optionLabel="system_name"
                                :class="{
                                    'p-invalid': error_iev_deviceOfVehicle_type && !iev_deviceOfVehicle_type
                                }"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="deviceTypeOptions">
                                    <div v-if="deviceTypeOptions.value">
                                        <div>{{ deviceTypeOptions.value.system_name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ deviceTypeOptions.placeholder }}
                                    </span>
                                </template>
                                <template #option="deviceTypeOptions">
                                    <div>{{ deviceTypeOptions.option.system_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_iev_deviceOfVehicle_type && !iev_deviceOfVehicle_type">{{
                                $t('iev_deviceOfVehicle_type_validate')
                            }}</small>
                        </div>
                    </div>
                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col">
                            <label for="iev_deviceOfVehicle_equipment"
                                >{{ $t('iev_deviceOfVehicle_equipment') }} <span class="required-input">*</span></label
                            >
                            <Dropdown
                                :disabled="disable_iev_deviceOfVehicle_equipment == 1"
                                v-model="iev_deviceOfVehicle_equipment"
                                optionLabel="device_name"
                                :class="{
                                    'p-invalid': error_iev_deviceOfVehicle_equipment && !iev_deviceOfVehicle_equipment
                                }"
                                :options="deviceOptions"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                                style="width: 330px"
                            >
                                <template #value="deviceOptions">
                                    <div v-if="deviceOptions.value">
                                        <div>{{ deviceOptions.value.device_name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ deviceOptions.placeholder }}
                                    </span>
                                </template>
                                <template #option="deviceOptions">
                                    <div class="EquipV">{{ deviceOptions.option.device_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_iev_deviceOfVehicle_equipment && !iev_deviceOfVehicle_equipment">{{
                                $t('iev_deviceOfVehicle_equipment_validate')
                            }}</small>
                        </div>
                    </div>
                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col">
                            <label for="iev_deviceOfVehicle_size">{{ $t('iev_deviceOfVehicle_size') }} <span class="required-input">*</span></label>
                            <InputText
                                id="iev_deviceOfVehicle_size"
                                type="text"
                                v-model="iev_deviceOfVehicle_size"
                                :class="{
                                    'p-invalid': error_iev_deviceOfVehicle_size && !iev_deviceOfVehicle_size
                                }"
                                ref="TextBox_1_Device"
                                @keyup.left="moveFocus($event, 'TextBox_4_Device', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2_Device', 'InputNumber')"
                                @keyup.down="moveFocus($event, 'TextBox_3_Device', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_iev_deviceOfVehicle_size && !iev_deviceOfVehicle_size">{{
                                $t('iev_deviceOfVehicle_size_validate')
                            }}</small>
                        </div>
                        <div class="p-field p-col">
                            <label for="iev_deviceOfVehicle_amount"
                                >{{ $t('iev_deviceOfVehicle_amount') }} <span class="required-input">*</span></label
                            >
                            <InputNumber
                                id="iev_deviceOfVehicle_amount"
                                v-model="iev_deviceOfVehicle_amount"
                                showButtons
                                :min="0"
                                :class="{
                                    'p-invalid': error_iev_deviceOfVehicle_amount && !iev_deviceOfVehicle_amount
                                }"
                                ref="TextBox_2_Device"
                                @keyup.left="moveFocus($event, 'TextBox_1_Device', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_3_Device', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_4_Device', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_iev_deviceOfVehicle_amount && !iev_deviceOfVehicle_amount">{{
                                $t('iev_deviceOfVehicle_amount_validate')
                            }}</small>
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <Button
                    :label="$t('clearBtn')"
                    icon="pi pi-times"
                    class="p-button-text"
                    @click="clearSubData()"
                    ref="TextBox_3_Device"
                    @keyup.left="moveFocus($event, 'TextBox_2_Device', 'InputNumber')"
                    @keyup.right="moveFocus($event, 'TextBox_4_Device', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_1_Device', 'Input')"
                />
                <Button
                    :label="$t('saveBtn')"
                    icon="pi pi-check"
                    class="p-button-text"
                    @click="saveDeviceData()"
                    ref="TextBox_4_Device"
                    @keyup.left="moveFocus($event, 'TextBox_3_Device', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1_Device', 'Input')"
                    @keyup.up="moveFocus($event, 'TextBox_2_Device', 'InputNumber')"
                />
            </template>
        </Dialog>

        <!-- ตารางการซ่อม -->
        <Dialog :modal="true" :visible.sync="addMaintenanceHistoryModal" :style="{ width: '80%', overflow: 'auto' }" :header="hearder_Maintenance">
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Mainten')">
                <label>{{ $t('ide_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-3">
                    <!-- <div class="p-formgrid p-grid p-col-12 p-grid  "> -->

                    <div class="p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-4">
                            <label for="Maintenance_name"
                                >ชื่อเจ้าหน้าที่
                                <span class="required-input">*</span>
                            </label>
                            <InputText
                                id="Maintenance_name"
                                type="text"
                                v-model="Maintenance_name"
                                ref="TextBox_1_Mainten"
                                @keyup.left="moveFocus($event, 'TextBox_5_Mainten', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2_Mainten', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_3_Mainten', 'Button')"
                                :class="{
                                    'p-invalid': error_Maintenance_name && !Maintenance_name
                                }"
                            />
                            <small class="p-invalid" v-if="error_Maintenance_name && !Maintenance_name">กรุณาระบุชื่อเจ้าหน้าที่</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-4">
                            <label for="Maintenance_tel"
                                >เบอร์โทรศัพท์ผู้ติดต่อ (โทรศัพท์มือถือ)
                                <span class="required-input">*</span>
                            </label>
                            <InputText
                                id="Maintenance_tel"
                                type="text"
                                v-model="Maintenance_tel"
                                ref="TextBox_2_Mainten"
                                @keyup.left="moveFocus($event, 'TextBox_1_Mainten', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_3_Mainten', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_3_Mainten', 'Button')"
                                @input="acceptNumberPhone5()"
                                :class="{
                                    'p-invalid': error_Maintenance_tel && !Maintenance_tel
                                }"
                            />
                            <small class="p-invalid" v-if="error_Maintenance_tel && Maintenance_tel.length !== 12"
                                >กรุณาระบุเบอร์โทรศัพท์ผู้ติดต่อ (โทรศัพท์มือถือ) 10 หลัก</small
                            >
                        </div>
                    </div>

                    <div class="p-field p-col-6 p-lg-2">
                        <Button
                            @click="addMaintenanceHistoryEditModal = true"
                            icon="pi pi-plus"
                            :label="$t('addBtn')"
                            class="p-button-success"
                            ref="TextBox_3_Mainten"
                            @keyup.left="moveFocus($event, 'TextBox_2_Mainten', 'Input')"
                            @keyup.right="moveFocus($event, 'TextBox_4_Mainten', 'Button')"
                            @keyup.up="moveFocus($event, 'TextBox_1_Mainten', 'Input')"
                            @keyup.down="moveFocus($event, 'TextBox_4_Mainten', 'Button')"
                        />
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12">
                            <DataTable
                                :value="MaintenanceEdit"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="5"
                                :rowHover="true"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                :rowsPerPageOptions="[5, 10, 20, 50]"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="index" header="ลำดับ" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.index }}
                                    </template>
                                </Column>

                                <Column field="no_report" :header="'เลขงาน'" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.no_report == null || dataTable.data.no_report == '' ? '-' : dataTable.data.no_report }}
                                    </template>
                                </Column>

                                <Column field="repair" header="รายการซ่อม" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <!-- {{ dataTable.data.repair }} -->
                                        {{ dataTable.data.repair == null || dataTable.data.repair == '' ? '-' : dataTable.data.repair }}
                                    </template>
                                </Column>
                                <Column field="behavior" :header="'อาการที่พบ'" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <!-- {{ dataTable.data.behavior }} -->
                                        {{ dataTable.data.behavior == null || dataTable.data.behavior == '' ? '-' : dataTable.data.behavior }}
                                    </template>
                                </Column>
                                <Column field="count" :header="'จำนวน'" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <!-- {{ dataTable.data.count }} -->
                                        {{ dataTable.data.count == null || dataTable.data.count == '' ? '-' : dataTable.data.count }}
                                    </template>
                                </Column>
                                <Column field="unit" :header="'หน่วยนับ'" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <!-- {{ dataTable.data.unit }} -->
                                        {{ dataTable.data.unit == null || dataTable.data.unit == '' ? '-' : dataTable.data.unit }}
                                    </template>
                                </Column>

                                <Column field="start_date" :header="'วันที่เข้าซ่อม'" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <!-- {{ dataTable.data.start_date }} -->
                                        {{ dataTable.data.start_date == null || dataTable.data.start_date == '' ? '-' : dataTable.data.start_date }}
                                        <!-- formatTimeMaintenance(dataTable.data.start_date) -->
                                    </template>
                                </Column>
                                <Column field="end_date" :header="'วันที่ปิดงาน'" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <!-- {{ dataTable.data.end_date }}   -->
                                        {{ dataTable.data.end_date == null || dataTable.data.end_date == '' ? '-' : dataTable.data.end_date }}
                                    </template>
                                </Column>
                                <Column :header="$t('controlTable')" headerStyle="width: 15rem;text-align: center">
                                    <template #body="dataTable">
                                        <div class="p-formgrid p-grid">
                                            <div class="p-field p-col-6">
                                                <Button
                                                    @click="
                                                        addMaintenanceHistoryEditModal = true;
                                                        editDataMaintenanceDetail(dataTable.data.id);
                                                    "
                                                    icon="pi pi-pencil"
                                                    :label="'แก้ไข'"
                                                    class="p-button-rounded p-button-warning"
                                                />
                                            </div>
                                            <div class="p-field p-col-6">
                                                <Button
                                                    @click="
                                                        // displayConfirmation = true;
                                                        deleteMaintenanceEdit = dataTable.data;
                                                        deleteAt = 'MaintenanceEdit-table';
                                                        alertDisplay(deleteMaintenanceEdit, deleteAt);
                                                    "
                                                    icon="pi pi-trash"
                                                    :label="$t('deleteBtn')"
                                                    class="p-button-rounded p-button-danger"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <Button
                    v-if="dataMainten != ''"
                    :label="'ยกเลิก'"
                    icon="pi pi-times"
                    class="p-button-text"
                    @click="(addMaintenanceHistoryModal = false), clearSubDataMaintenance()"
                    ref="TextBox_4_Mainten"
                    @keyup.left="moveFocus($event, 'TextBox_3_Mainten', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_5_Mainten', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_3_Mainten', 'Button')"
                />
                <Button
                    v-else
                    :label="$t('clearBtn')"
                    icon="pi pi-times"
                    class="p-button-text"
                    @click="clearSubDataMaintenance()"
                    ref="TextBox_4_Mainten"
                    @keyup.left="moveFocus($event, 'TextBox_3_Mainten', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_5_Mainten', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_3_Mainten', 'Button')"
                />
                <!-- @keyup.enter="saveData_Modal('Mainten')" -->
                <Button
                    :label="$t('saveBtn')"
                    icon="pi pi-check"
                    class="p-button-text"
                    @click="saveMaintenanceHistory()"
                    ref="TextBox_5_Mainten"
                    @keyup.left="moveFocus($event, 'TextBox_4_Mainten', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1_Mainten', 'Input')"
                    @keyup.up="moveFocus($event, 'TextBox_3_Mainten', 'Button')"
                />
            </template>
        </Dialog>

        <!-- เพิ่มประวัติการซ่อมบำรุง -->
        <Dialog
            :modal="true"
            :visible.sync="addMaintenanceHistoryEditModal"
            :style="{ width: '500px' }"
            :header="hearder_Maintenance_Edit"
            :contentStyle="setDialogScroll"
        >
            <div class="confirmation-content" @keyup.enter="saveData_Modal('MaintenDetail')">
                <label>{{ $t('ide_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-3">
                    <!-- autofocus -->
                    <div class="p-formgrid p-grid p-col-12 p-grid">
                        <div class="p-field p-col-12 p-lg-12">
                            <label for="Maintenance_no_report">เลขงาน</label>
                            <InputText
                                id="Maintenance_no_report"
                                type="text"
                                v-model="Maintenance_no_report"
                                ref="TextBox_1_maintenEdit"
                                @keyup.left="moveFocus($event, 'TextBox_6_maintenEdit', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2_maintenEdit', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_2_maintenEdit', 'Input')"
                            />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12 p-grid">
                        <div class="p-field p-col-12 p-lg-6">
                            <label for="Maintenance_repair"
                                >รายการซ่อม
                                <span class="required-input">*</span>
                            </label>
                            <InputText
                                id="Maintenance_repair"
                                type="text"
                                v-model="Maintenance_repair"
                                ref="TextBox_2_maintenEdit"
                                @keyup.left="moveFocus($event, 'TextBox_1_maintenEdit', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_3_maintenEdit', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_1_maintenEdit', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_4_maintenEdit', 'Input')"
                                :class="{
                                    'p-invalid': error_Maintenance_repair && !Maintenance_repair
                                }"
                            />
                            <small class="p-invalid" v-if="error_Maintenance_repair && !Maintenance_repair">กรุณาระบุรายการซ่อม</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-6">
                            <label for="Maintenance_behavior"
                                >อาการที่พบ
                                <span class="required-input"></span>
                            </label>
                            <InputText
                                id="Maintenance_behavior"
                                type="text"
                                v-model="Maintenance_behavior"
                                ref="TextBox_3_maintenEdit"
                                @keyup.left="moveFocus($event, 'TextBox_2_maintenEdit', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_4_maintenEdit', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_1_maintenEdit', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_4_maintenEdit', 'Input')"
                            />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12 p-grid">
                        <div class="p-field p-col-12 p-lg-6">
                            <label for="Maintenance_count">จำนวน</label>
                            <InputText
                                id="Maintenance_count"
                                type="text"
                                v-model="Maintenance_count"
                                @input="acceptNumberPhone6()"
                                min="0.00"
                                ref="TextBox_4_maintenEdit"
                                @keyup.left="moveFocus($event, 'TextBox_3_maintenEdit', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_5_maintenEdit', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_2_maintenEdit', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_5_maintenEdit', 'Button')"
                            />
                        </div>

                        <div class="p-field p-col-12 p-lg-6">
                            <label for="Maintenance_behavior">หน่วยนับ</label>
                            <!-- <InputText
                id="Maintenance_unit"
                type="text"
                v-model="Maintenance_unit"
              /> -->
                            <Dropdown
                                v-model="Maintenance_unit"
                                :options="unitNameOptions"
                                optionLabel="system_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="unitNameOptions">
                                    <div v-if="unitNameOptions.value" class="DD_data">
                                        <div>{{ unitNameOptions.value.system_name }}</div>
                                    </div>
                                    <div class="DD_data" v-else>
                                        {{ unitNameOptions.placeholder }}
                                    </div>
                                </template>
                                <template #option="unitNameOptions">
                                    <div>{{ unitNameOptions.option.system_name }}</div>
                                </template>
                            </Dropdown>
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-6" ref="maintenEdit_calendar">
                            <label for="iev_historyOfMaintenance_startdate">วันที่เข้าซ่อม <span class="required-input"></span></label>
                            <!-- yearRange="2000:2050" -->
                            <Calendar
                                dateFormat="dd/mm/yy"
                                :maxDate="date_yearRange"
                                :manualInput="true"
                                :showButtonBar="true"
                                :monthNavigator="true"
                                :yearNavigator="true"
                                :yearRange="`2000:${setYearRange(date_yearRange, 0, 'plus')}`"
                                :locale="th"
                                @input="updateEndDateMinDate"
                                id="iev_historyOfMaintenance_startdate"
                                v-model="iev_historyOfMaintenance_startdate"
                                :class="{
                                    'p-invalid': error_iev_historyOfMaintenance_startdate && !iev_historyOfMaintenance_startdate
                                }"
                            ></Calendar>
                            <small class="p-invalid" v-if="error_iev_historyOfMaintenance_startdate && !iev_historyOfMaintenance_startdate">{{
                                $t('iev_historyOfMaintenance_startdate_validate')
                            }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-6">
                            <label for="iev_historyOfMaintenance_enddate">วันที่ปิดงาน <span class="required-input"></span></label>
                            <!-- :minDate="date_yearRange" -->
                            <Calendar
                                dateFormat="dd/mm/yy"
                                :minDate="iev_historyOfMaintenance_startdate"
                                :showButtonBar="true"
                                :manualInput="true"
                                :monthNavigator="true"
                                :yearNavigator="true"
                                :yearRange="`2000:${setYearRange(date_yearRange, 1, 'plus')}`"
                                :locale="th"
                                id="iev_historyOfMaintenance_enddate"
                                v-model="iev_historyOfMaintenance_enddate"
                                :class="{
                                    'p-invalid': error_iev_historyOfMaintenance_enddate && !iev_historyOfMaintenance_enddate
                                }"
                            ></Calendar>
                            <small class="p-invalid" v-if="error_iev_historyOfMaintenance_enddate && !iev_historyOfMaintenance_enddate">{{
                                $t('iev_historyOfMaintenance_enddate_validate')
                            }}</small>
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <Button
                    v-if="dataMaintenDetail != ''"
                    :label="'ยกเลิก'"
                    icon="pi pi-times"
                    class="p-button-text"
                    @click="(addMaintenanceHistoryEditModal = false), clearSubData()"
                    ref="TextBox_5_maintenEdit"
                    @keyup.left="moveFocus($event, 'TextBox_4_maintenEdit', 'Input')"
                    @keyup.right="moveFocus($event, 'TextBox_6_maintenEdit', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_4_maintenEdit', 'Input')"
                />
                <Button
                    v-else
                    :label="$t('clearBtn')"
                    icon="pi pi-times"
                    class="p-button-text"
                    @click="clearSubData()"
                    ref="TextBox_5_maintenEdit"
                    @keyup.left="moveFocus($event, 'TextBox_4_maintenEdit', 'Input')"
                    @keyup.right="moveFocus($event, 'TextBox_6_maintenEdit', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_4_maintenEdit', 'Input')"
                />
                <Button
                    :label="$t('saveBtn')"
                    icon="pi pi-check"
                    class="p-button-text"
                    @click="saveHistory()"
                    ref="TextBox_6_maintenEdit"
                    @keyup.left="moveFocus($event, 'TextBox_5_maintenEdit', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1_maintenEdit', 'Input')"
                    @keyup.up="moveFocus($event, 'TextBox_4_maintenEdit', 'Input')"
                />
            </template>
        </Dialog>
        <!-- <Dialog
      :modal="true"
      :visible.sync="addMaintenanceHistoryModal"
      :style="{ width: '500px' }"
      :header="header_historyOfMaintenance"
    >
      <div class="confirmation-content">
        <label>{{ $t("ide_modal_subtitle") }}</label>
        <div class="p-fluid p-mt-3">
          <div class="p-formgrid p-grid p-col-12">
            <div class="p-field p-col-12">
              <label for="iev_historyOfMaintenance_startdate"
                >{{ $t("iev_historyOfMaintenance_startdate") }}
                <span class="required-input">*</span></label
              >
              <Calendar
                dateFormat="dd/mm/yy"
                :maxDate="maxDate"
                :showButtonBar="true"
                :monthNavigator="true"
                :yearNavigator="true"
                yearRange="2000:2050"
                :locale="th"
                id="iev_historyOfMaintenance_startdate"
                v-model="iev_historyOfMaintenance_startdate"
                :class="{
                  'p-invalid':
                    error_iev_historyOfMaintenance_startdate &&
                    !iev_historyOfMaintenance_startdate,
                }"
              ></Calendar>
              <small
                class="p-invalid"
                v-if="
                  error_iev_historyOfMaintenance_startdate &&
                  !iev_historyOfMaintenance_startdate
                "
                >{{ $t("iev_historyOfMaintenance_startdate_validate") }}</small
              >
            </div>
            <div class="p-field p-col-12">
              <label for="iev_historyOfMaintenance_enddate"
                >{{ $t("iev_historyOfMaintenance_enddate") }}
                <span class="required-input">*</span></label
              >
              <Calendar
                dateFormat="dd/mm/yy"
                :minDate="minDate"
                :showButtonBar="true"
                :monthNavigator="true"
                :yearNavigator="true"
                yearRange="2000:2050"
                :locale="th"
                id="iev_historyOfMaintenance_enddate"
                v-model="iev_historyOfMaintenance_enddate"
                :class="{
                  'p-invalid':
                    error_iev_historyOfMaintenance_enddate &&
                    !iev_historyOfMaintenance_enddate,
                }"
              ></Calendar>
              <small
                class="p-invalid"
                v-if="
                  error_iev_historyOfMaintenance_enddate &&
                  !iev_historyOfMaintenance_enddate
                "
                >{{ $t("iev_historyOfMaintenance_enddate_validate") }}</small
              >
            </div>
          </div>
          <div class="p-formgrid p-grid p-col-12">
            <div class="p-field p-col">
              <label for="iev_historyOfMaintenance_detail">{{
                $t("iev_historyOfMaintenance_detail")
              }}</label>
              <Textarea
                id="iev_historyOfMaintenance_detail"
                type="text"
                rows="3"
                v-model="iev_historyOfMaintenance_detail"
                autofocus
              />
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          :label="$t('clearBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="clearSubData()"
        />
        <Button
          :label="$t('saveBtn')"
          icon="pi pi-check"
          class="p-button-text"
          @click="saveHistory()"
        />
      </template>
    </Dialog> -->

        <!-- เพิ่มประวัติการยืม -->
        <Dialog :modal="true" :visible.sync="addBorrowingHistoryModal" :style="{ width: '500px' }" :header="header_historyOfBorrowing">
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Borrowing')">
                <label>{{ $t('ide_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-3">
                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12">
                            <label for="iev_historyOfBorrowing_startdate"
                                >{{ $t('iev_historyOfBorrowing_startdate') }} <span class="required-input">*</span></label
                            >
                            <Calendar
                                dateFormat="dd/mm/yy"
                                :maxDate="setTimeMaxMin(maxDate)"
                                :manualInput="true"
                                :showButtonBar="true"
                                :monthNavigator="true"
                                :yearNavigator="true"
                                :yearRange="`2000:${setYearRange(date_yearRange, 1, 'plus')}`"
                                :locale="th"
                                id="iev_historyOfBorrowing_startdate"
                                v-model="iev_historyOfBorrowing_startdate"
                                :class="{
                                    'p-invalid': error_iev_historyOfBorrowing_startdate && !iev_historyOfBorrowing_startdate
                                }"
                            ></Calendar>
                            <small class="p-invalid" v-if="error_iev_historyOfBorrowing_startdate && !iev_historyOfBorrowing_startdate">{{
                                $t('iev_historyOfBorrowing_startdate_validate')
                            }}</small>
                        </div>
                        <div class="p-field p-col-12">
                            <label for="iev_historyOfBorrowing_enddate"
                                >{{ $t('iev_historyOfBorrowing_enddate') }} <span class="required-input">*</span></label
                            >
                            <Calendar
                                dateFormat="dd/mm/yy"
                                :manualInput="true"
                                :minDate="setTimeMaxMin(minDate)"
                                :showButtonBar="true"
                                :monthNavigator="true"
                                :yearNavigator="true"
                                :yearRange="`2000:${setYearRange(date_yearRange, 1, 'plus')}`"
                                :locale="th"
                                id="iev_historyOfBorrowing_enddate"
                                v-model="iev_historyOfBorrowing_enddate"
                                :class="{
                                    'p-invalid': error_iev_historyOfBorrowing_enddate && !iev_historyOfBorrowing_enddate
                                }"
                            ></Calendar>
                            <small class="p-invalid" v-if="error_iev_historyOfBorrowing_enddate && !iev_historyOfBorrowing_enddate">{{
                                $t('iev_historyOfBorrowing_enddate_validate')
                            }}</small>
                        </div>
                    </div>
                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col">
                            <label for="iev_historyOfBorrowing_detail">{{ $t('iev_historyOfBorrowing_detail') }}</label>
                            <Textarea
                                id="iev_historyOfBorrowing_detail"
                                type="text"
                                rows="3"
                                v-model="iev_historyOfBorrowing_detail"
                                ref="TextBox_1_Borrowing"
                                @keyup.left="moveFocus($event, 'TextBox_3_Borrowing', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2_Borrowing', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_2_Borrowing', 'Button')"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <Button
                    :label="$t('clearBtn')"
                    icon="pi pi-times"
                    class="p-button-text"
                    @click="clearSubData()"
                    ref="TextBox_2_Borrowing"
                    @keyup.left="moveFocus($event, 'TextBox_1_Borrowing', 'Input')"
                    @keyup.right="moveFocus($event, 'TextBox_3_Borrowing', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_1_Borrowing', 'Input')"
                />
                <Button
                    :label="$t('saveBtn')"
                    icon="pi pi-check"
                    class="p-button-text"
                    @click="saveHistoryBorrowing()"
                    ref="TextBox_3_Borrowing"
                    @keyup.left="moveFocus($event, 'TextBox_2_Borrowing', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1_Borrowing', 'Input')"
                    @keyup.up="moveFocus($event, 'TextBox_1_Borrowing', 'Input')"
                />
            </template>
        </Dialog>

        <!-- Are you sure for close this modal -->
        <Dialog :modal="true" :header="$t('ConfirmCloseModal')" :visible.sync="displayConfirmationCloseModal" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <span>{{ $t('ConfirmCloseModalSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmationCloseModal = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="closeAllModal()" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <!-- Image -->
        <Dialog :modal="true" :header="$t('imageEquipment')" :visible.sync="displayImageModal" :style="{ width: '400px' }">
            <div class="img-content p-mt-5 p-mb-5">
                <img :src="imgEquipment" alt="" v-if="imgEquipment" />
                <div v-else class="p-text-center">{{ $t('NoImageEquipment') }}</div>
            </div>
        </Dialog>

        <Galleria
            :value="imgTable"
            containerStyle="max-width: 850px"
            :circular="true"
            :fullScreen="true"
            :showItemNavigators="false"
            :showThumbnails="false"
            :visible.sync="displayBasic2"
        >
            <template #item="slotProps">
                <img :src="imgTable" class="imgDia" alt="" />
            </template>
        </Galleria>

        <!-- Doe PDF เลือกได้  -->
        <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" :style="{ width: '25rem' }" :contentStyle="{ 'overflow-y': 'visible' }">
            <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
            <div style="margin: 2.5rem 1rem 0 1rem">
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12">
                        <MultiSelect
                            v-model="columnsSelectorDialog"
                            :options="columns"
                            optionLabel="title"
                            :placeholder="$t('placeholderSelectBox')"
                            :filter="true"
                            class="multiselect-custom"
                            :clearFilterMultiSelect="multiSelectClearFilerValue"
                        >
                            <template #value="slotProps">
                                <div class="item item-value" v-for="option of slotProps.value" :key="option.dataKey">
                                    <div>{{ option.title }}</div>
                                </div>
                                <template v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ $t('placeholderSelectBox') }}
                                </template>
                            </template>
                            <template #option="slotProps">
                                <div class="item">
                                    <div>{{ slotProps.option.title }}</div>
                                </div>
                            </template>
                        </MultiSelect>
                        <div style="margin-top: 1rem; display: flex; justify-content: flex-end">
                            <Button
                                @click="
                                    ClearEditPDF();
                                    multiSelectClearFilerValue += 1;
                                "
                                class="p-button-clear"
                                :label="'ล้างข้อมูล'"
                                style="margin-right: 1rem"
                            />
                            <Button @click="SelectAllEditPDF()" class="p-button-info" :label="'เลือกทั้งหมด'" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div>
                    <Button @click="CloseEditPDF()" :label="'ยกเลิก'" icon="pi pi-times" class="p-button-text" />
                    <Button @click="SaveEditPDF()" :label="'บันทึก'" icon="pi pi-check" class="p-button-text" />
                </div>
            </template>
        </Dialog>
        <!-- Doe PDF เลือกได้ -->
    </div>
</template>

<script>
import organizeForm from '../../Information/OrganizeTableForm.vue';
import organizeTable from '../OrganizeMultiSelectTable.vue';
// Doe : PDF 2/3
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import moment from 'moment';

import textFooter from '../../../mixins/textFooter_Search_html.vue';

export default {
    name: 'report-equipment-status',
    components: {
        organizeTable,
        organizeForm,
        textFooter
    },
    data() {
        return {
            ie_equipment_community: null,
            communityOptions: [],
            dropdownClearFilerValue: 0,
            loading: false,
            equipment_community: null,
            ie_equipment_code: '',
            columns_status3: true,
            columns_status4: true,
            equipment_code: '',
            multiSelectClearFilerValue: 0,
            minEndDate: null,
            date: moment().locale('th').add(543, 'year').format('l'),
            date_yearRange: new Date(),
            pic: '',
            // Doe ค้นหา  2/5
            // dropdownClearFilerValue: 0,
            filter: '',
            ms: false,
            cloneTable: [],
            // Doe ค้นหา  2/5 จบ

            // Doe โหลด โทรศัพท์
            // Doe width 1/4
            window: {
                width: 0,
                height: 0
            },

            //Search bar variable
            checkRole: null,
            checkView_data: null,
            checkAdd_data: null,
            checkEdit_data: null,
            checkDelete_data: null,
            th: this.$thaidate,
            selectedOrganize: {},
            equipment_name: '',
            update_info: '0',
            equipmentGroupOptions: [
                { system_id: 'getall', system_name: this.$i18n.t('selectAll') },
                { system_id: 'vehicle', system_name: this.$i18n.t('vehicle') },
                { system_id: 'device', system_name: this.$i18n.t('device') }
            ],
            // equipmentGroupSelected: {
            //             system_id: "getall",
            //             system_name: this.$i18n.t("selectAll"),
            //           },
            equipmentGroupSelected: null,
            equipmentTypeOptions: [],
            equipmentTypeSelected: null,
            disabledEquiptype: 1,

            equipment_standard_name: null,

            displayConfirmation: false,
            filters: {},
            selectedEquipmentInfo: [],
            equipmentInfo_Table: [],

            showOrganize: false,
            showOrganize_Form: false,
            selectedData: '',
            equipmentInfoModal: false,
            showDeviceOfVehicle: false,
            addDeviceOfVehicleModal: false,

            checkKey_modalDevice: false,

            addMaintenanceHistoryModal: false,
            MaintenanceHistory: [],
            MaintenanceEdit: [],
            MaintenanceEdit_Text: [],
            deleteMaintenanceEdit: {},
            dataMainten: '',
            dataMaintenDetail: '',

            hearder_Maintenance: 'เพิ่มข้อมูลประวัติการซ่อมบำรุง',
            hearder_Maintenance_Edit: 'เพิ่มข้อมูลรายละเอียดการซ่อมบำรุง',
            Maintenance_name: '',
            error_Maintenance_name: false,
            Maintenance_tel: '',
            error_Maintenance_tel: false,

            Maintenance_repair: '',
            error_Maintenance_repair: false,
            Maintenance_behavior: '',
            Maintenance_no_report: '',
            Maintenance_count: '',
            Maintenance_unit: null,
            unitNameOptions: [],
            // Maintenance_repair:"",

            addMaintenanceHistoryEditModal: false,

            addBorrowingHistoryModal: false,

            deviceOfVehicle_table: [],
            deviceOptions: [],
            deviceTypeOptions: [],
            standard_nameOptions: [],
            url: null,
            iev_equipment_name: '',
            iev_equipment_lat: '',
            iev_equipment_lon: '',
            iev_equipment_number: '',
            iev_equipment_amount: 0,
            iev_sidecar_number: '',
            iev_car_brand: null,
            brands: [],
            iev_received_date: null,
            iev_license_car: '',
            iev_organize: {},
            iev_equipment_group: null,
            iev_equipment_type: null,
            // standardName
            iev_equipment_standard_name: null,
            equipmentStatusOptions: [
                { id: '1', name: this.$i18n.t('status_ready') },
                { id: '2', name: this.$i18n.t('status_fix') },
                { id: '3', name: this.$i18n.t('status_bad') },
                { id: '4', name: this.$i18n.t('status_waitSale') },
                { id: '5', name: this.$i18n.t('status_sale') },
                { id: '6', name: this.$i18n.t('status_bad_device') }
            ],
            iev_StatusOptions_Search: [
                { id: '', name: 'เลือกทั้งหมด' },
                { id: '1', name: this.$i18n.t('status_ready') },
                { id: '2', name: this.$i18n.t('status_fix') },
                { id: '3', name: this.$i18n.t('status_bad') },
                { id: '4', name: this.$i18n.t('status_waitSale') },
                { id: '5', name: this.$i18n.t('status_sale') },
                { id: '6', name: this.$i18n.t('status_bad_device') }
            ],
            iev_status_Search: null,
            iev_sideNum_Style: 'p-field p-col-12 p-lg-12 p-mt-2 ',
            iev_sideNum_Search: null,
            iev_sideNum_Search_Selector: null,
            // iev_equipment_status: null,
            iev_equipment_status: { id: '1', name: this.$i18n.t('status_ready') },
            iev_position: '',
            iev_response_contact_name: '',
            iev_contact_phone: '',
            iev_update_info_date: '', //show
            iev_update_info_date_save: '',
            iev_detail: '',
            iev_update_info: [],

            error_iev_equipment_name: false,
            error_iev_equipment_number: false,
            error_iev_equipment_group: false,
            error_iev_organize: false,
            error_iev_equipment_type: false,
            // standard_name
            error_iev_equipment_standard_name: false,

            contact_phone: '',
            contact_phone_office: '',
            contact_phone_office_ext: '',

            error_contact_phone: false,
            error_contact_phone_office: false,
            error_contact_phone_office_ext: false,

            iev_phone: [],

            iev_deviceOfVehicle_type: null,
            disable_iev_deviceOfVehicle_equipment: 1,
            iev_deviceOfVehicle_equipment: null,
            iev_deviceOfVehicle_size: '',
            iev_deviceOfVehicle_amount: 0,
            error_iev_deviceOfVehicle_type: false,
            error_iev_deviceOfVehicle_equipment: false,
            error_iev_deviceOfVehicle_size: false,
            error_iev_deviceOfVehicle_amount: false,

            historyOfMaintenance_table: [],
            // iev_historyOfMaintenance_startdate: "",
            // iev_historyOfMaintenance_enddate: "",
            iev_historyOfMaintenance_startdate: '',
            iev_historyOfMaintenance_enddate: '',
            iev_historyOfMaintenance_detail: '',

            ev_borrowing_history: [],
            iev_historyOfBorrowing_startdate: '',
            iev_historyOfBorrowing_enddate: '',
            iev_historyOfBorrowing_detail: '',

            deleteAt: '',
            deleteDevice: {},
            deleteHistory: {},
            deleteHistoryBorrowing: {},
            header: this.$i18n.t('iev_modal_title_add'),
            header_deviceOfVehicle: this.$i18n.t('iev_header_deviceOfVehicle'),
            header_historyOfMaintenance: this.$i18n.t('iev_header_historyOfMaintenance'),
            header_historyOfBorrowing: this.$i18n.t('iev_header_historyOfBorrowing'),

            error_email_format: false,
            displayConfirmationCloseModal: false,
            tempFor_displayConfirmationCloseModal: '',
            minDate: null,
            maxDate: null,
            // minDate: "",
            // maxDate: "",

            error_iev_historyOfMaintenance_startdate: false,
            error_iev_historyOfMaintenance_enddate: false,

            error_iev_historyOfBorrowing_startdate: false,
            error_iev_historyOfBorrowing_enddate: false,

            displayImageModal: false,
            imgEquipment: null,
            temp: null,

            selectedOrganizeData: [],
            organize_table: [],
            parentmessage_organize: null,
            //
            setOpenModal_Organize: '',
            setOpenModal_OrganizeMulti: '',

            // โหลดเพิ่มแก้ไข 3/8
            loadingCreate: false,
            // โหลดเพิ่มแก้ไข 3/8 จบ
            // Doe : PDF 3/3

            //
            text_Footer: false,
            Clone_Data_text_Footer: [],
            Data_text_Footer: [
                {
                    DataName: 'หน่วยงานที่รับผิดชอบ',
                    textShow: ''
                },
                {
                    DataName: 'ชื่อเครื่องมือฯ',
                    textShow: ''
                },
                {
                    DataName: 'สถานะ',
                    textShow: ''
                },
                {
                    DataName: 'กลุ่มเครื่องมือฯ',
                    textShow: ''
                },
                {
                    DataName: 'ประเภทเครื่องมือฯ',
                    textShow: ''
                },
                {
                    DataName: 'หมายเลขข้างรถ',
                    textShow: ''
                },
                {
                    DataName: 'ต้องปรับปรุงข้อมูล',
                    textShow: ''
                }
            ],

            setDialogScroll: {},
            zoomLevel: 0,

            table_BOXmanege: window.innerWidth > 700 ? 'p-field p-col' : '',
            table_editBTN: window.innerWidth > 700 ? this.$i18n.t('editBtn') : '',
            table_deleteBTN: window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '',

            table_headerStyle: this.checkInnerWidth('15rem', 'Column'),
            table_bodyStyle: this.checkInnerWidth('15rem', 'Body'),

            date_create_form: '',
            date_update_form: '',
            // Doe PDF เลือกได้  2/5
            setPDF_Hor: 'l',
            setPosition_Hor: [802, 34, 802, 570],
            setPDF_Ver: 'p',
            setPosition_Ver: [570, 34, 575, 815],
            setPDF_Styles: 'grid',
            setnamePDF: 'รายละเอียดข้อมูลสถานะของอุปกรณ์ยานพาหนะ (ชื่อมาตรฐาน)',
            setPDF_fillColor: [95, 154, 250],
            setPDF_Margin: { left: 15, right: 15 },

            PDF_minCellWidthVer: 38,
            PDF_FontHeaderVer: 5.5,
            PDF_FontBodyVer: 5.5,

            PDF_BodySizeSelect: {},
            PDF_BodySize: {
                index: { cellWidth: 18 },
                ev_name: { cellWidth: 30 },
                // ev_standard_name:{cellWidth:38},
                group: { cellWidth: 32 },
                // system_name:{cellWidth:38},
                ev_number: { cellWidth: 28 },
                ev_license_plate: { cellWidth: 28 },
                ev_sidecar_number: { cellWidth: 24 },
                ev_car_brand: { cellWidth: 28 },
                ev_received_date: { cellWidth: 34 },
                organize_name: { cellWidth: 32 },

                text_tel_detail: { cellWidth: 28 },
                // ev_response_phone:{cellWidth:28},

                ev_detail: { cellWidth: 27 },
                ev_response_name: { cellWidth: 28 },

                status: { cellWidth: 22 },
                ev_amount: { cellWidth: 21 },
                user_fullname: { cellWidth: 30 },

                date_create_ddmmyy: { cellWidth: 35 },
                date_update_ddmmyy: { cellWidth: 34 }
            },

            PDF_minCellWidthHor: 40,
            PDF_FontHeaderHor: 7,
            PDF_FontBodyHor: 5.5,

            PDF_BodySizeHorSelect: {},
            PDF_BodySizeHor: {
                index: { cellWidth: 21.5 },
                // ev_name:{cellWidth:50},
                ev_standard_name: { cellWidth: 48 },
                // group:{cellWidth:50},
                system_name: { cellWidth: 50 },
                ev_number: { cellWidth: 35 },
                ev_license_plate: { cellWidth: 50 },
                ev_sidecar_number: { cellWidth: 35 },
                ev_car_brand: { cellWidth: 35 },
                ev_received_date: { cellWidth: 35 },
                organize_name: { cellWidth: 70 },

                text_tel_detail: { cellWidth: 40 },
                // ev_response_phone:{cellWidth:40},

                ev_detail: { cellWidth: 49 },
                ev_response_name: { cellWidth: 39 },

                // status:{cellWidth:40},
                ev_amount: { cellWidth: 32 },
                ev_date: { cellWidth: 55 },

                user_fullname: { cellWidth: 45 },
                date_create_ddmmyy: { cellWidth: 35 },
                date_update_ddmmyy: { cellWidth: 42 }
            },
            columns: [
                { title: 'ลำดับ', dataKey: 'index' },
                // { title: 'ชื่อเครื่องมือมาตรฐาน', dataKey: 'standard_name' },
                { title: 'หน่วยงาน', dataKey: 'organize_name' },
                { title: 'พร้อมใช้', dataKey: 'status1' },
                { title: 'ซ่อม', dataKey: 'status2' },
                { title: 'ชำรุด', dataKey: 'status3' },
                { title: 'รอจำหน่าย', dataKey: 'status4' },
                { title: 'จำหน่าย', dataKey: 'status5' },
                { title: 'อุปกรณ์ชำรุด', dataKey: 'status6' },
                { title: 'รวม', dataKey: 'total' }
            ],

            columnsSelector: null,
            columnsSelectorDialog: null,

            displayEditPDF: false,

            columns_index: true,
            columns_img: true,
            columns_checkbox: true,
            columns_img_cloud: true,
            columns_ev_name: true,
            columns_ev_standard_name: true,
            columns_ev_organize_name: true,
            columns_status1: true,
            columns_status2: true,
            columns_status5: true,
            columns_status6: true,
            columns_total: true,
            columns_ev_car_brand: true,
            columns_received_date: true,
            columns_organize_name: true,
            columns_status: true,

            columns_ev_detail: true,
            columns_ev_amount: true,
            columns_ev_response_name: true,

            columns_text_tel_detail: true,
            columns_ev_response_phone: true,

            columns_ev_date: true,
            columns_user_fullname: true,

            columns_date_create: true,
            columns_date_update: true,

            columns_disabled: true,
            GetData_ColumnsSearch: [],

            imgTable: null,
            displayBasic2: false,
            // Doe PDF เลือกได้  2/5  จบ

            items: [
                {
                    label: ' แนวตั้ง',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวตั้ง', life: 3000 });

                        let columns = this.columnsSelector;
                        columns = columns.filter(function (item) {
                            return item.dataKey != 'ev_image';
                        });

                        const Body_setCenter = ['index', 'ev_amount', 'group', 'system_name', 'status'];

                        const fill_row_detail = [
                            {
                                name_row: 'status',
                                detail_row: [
                                    {
                                        check_text: 'พร้อมใช้',
                                        fill_color: [88, 214, 141]
                                    },
                                    {
                                        check_text: 'ซ่อม',
                                        fill_color: [221, 0, 0]
                                    },
                                    {
                                        check_text: 'ชำรุด',
                                        fill_color: [231, 76, 60]
                                    },
                                    {
                                        check_text: 'อุปกรณ์ชำรุด',
                                        fill_color: [231, 76, 60]
                                    },
                                    {
                                        check_text: 'รอจำหน่าย',
                                        fill_color: [241, 148, 138]
                                    },
                                    {
                                        check_text: 'จำหน่าย',
                                        fill_color: [250, 219, 216]
                                    }
                                ]
                            }
                        ];

                        const PintPDF = {
                            streak: this.setPDF_Ver,
                            setPosition: this.setPosition_Ver,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderVer,
                            Body_FontSize: this.PDF_FontBodyVer,
                            minCell: this.PDF_minCellWidthVer,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor,
                            //
                            check_fill_row: true,
                            fill_row_detail: fill_row_detail
                        };
                        this.printPDF(PintPDF);
                    }
                },

                {
                    label: 'แนวนอน',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวนอน', life: 3000 });

                        let columns = this.columnsSelector;
                        columns = columns.filter(function (item) {
                            return item.dataKey != 'ev_image';
                        });

                        const Body_setCenter = ['index', 'ev_amount', 'group', 'system_name', 'status'];

                        const fill_row_detail = [
                            {
                                name_row: 'status',
                                detail_row: [
                                    {
                                        check_text: 'พร้อมใช้',
                                        fill_color: [88, 214, 141]
                                    },
                                    {
                                        check_text: 'ซ่อม',
                                        fill_color: [221, 0, 0]
                                    },
                                    {
                                        check_text: 'ชำรุด',
                                        fill_color: [231, 76, 60]
                                    },
                                    {
                                        check_text: 'อุปกรณ์ชำรุด',
                                        fill_color: [231, 76, 60]
                                    },
                                    {
                                        check_text: 'รอจำหน่าย',
                                        fill_color: [241, 148, 138]
                                    },
                                    {
                                        check_text: 'จำหน่าย',
                                        fill_color: [250, 219, 216]
                                    }
                                ]
                            }
                        ];

                        const PintPDF = {
                            streak: this.setPDF_Hor,
                            setPosition: this.setPosition_Hor,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeHorSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderHor,
                            Body_FontSize: this.PDF_FontBodyHor,
                            minCell: this.PDF_minCellWidthHor,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor,
                            //
                            check_fill_row: true,
                            fill_row_detail: fill_row_detail
                        };
                        this.printPDF(PintPDF);
                    }
                }
            ]
            // Doe : PDF 3/3 จบ
        };
    },
    watch: {
        iev_equipment_number() {
            this.acceptNumberEquipmentNumber();
        },
        equipmentInfoModal(val) {
            const today = new Date();
            const thaiDate = today.toLocaleDateString('th-TH', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });

            if (val == false) {
                if (
                    this.tempFor_displayConfirmationCloseModal == '' &&
                    this.selectedData == '' &&
                    this.iev_equipment_name != '' &&
                    this.iev_organize.name != undefined &&
                    this.iev_equipment_group != null &&
                    this.iev_equipment_type != null
                ) {
                    // this.displayConfirmationCloseModal = true;
                    this.$fire({
                        title: 'ยืนยันการปิดหน้าต่างจัดการข้อมูล',
                        text: 'คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?',

                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'ตกลง',
                        cancelButtonText: 'ยกเลิก'
                    }).then((result) => {
                        if (result.value) {
                            this.iev_equipment_name = '';
                            this.iev_equipment_group = {
                                system_id: 'device',
                                system_name: this.$i18n.t('device')
                            };
                            this.iev_equipment_status = {
                                id: '1',
                                name: this.$i18n.t('status_ready')
                            };
                            this.iev_equipment_standard_name = null;
                            this.iev_equipment_type = null;
                            this.iev_equipment_number = '';
                            this.iev_equipment_amount = 0;

                            this.iev_license_car = '';
                            this.iev_response_contact_name = '';
                            this.iev_position = '';
                            this.iev_contact_phone = '';
                            this.iev_detail = '';
                            this.iev_sidecar_number = '';
                            this.iev_car_brand = null;
                            this.iev_received_date = null;
                            this.iev_organize = '';
                            this.iev_update_info = [];
                            this.deviceOfVehicle_table = [];
                            this.historyOfMaintenance_table = [];
                            this.ev_borrowing_history = [];
                            this.tempFor_displayConfirmationCloseModal = '';
                            this.url = null;

                            this.error_iev_equipment_name = false;
                            this.error_iev_equipment_number = false;
                            this.error_iev_equipment_group = false;
                            this.error_iev_equipment_type = false;
                            this.error_iev_organize = false;
                            this.error_iev_equipment_standard_name = false;
                            this.equipmentInfoModal = false;

                            this.MaintenanceHistory = [];
                            this.MaintenanceEdit = [];

                            this.contact_phone = '';
                            this.contact_phone_office = '';
                            this.contact_phone_office_ext = '';

                            this.error_contact_phone = false;
                            this.error_contact_phone_office = false;
                            this.error_contact_phone_office_ext = false;

                            this.pic = '';

                            this.date_create_form = '';
                            this.date_update_form = '';

                            this.clearSubData();
                            this.clearSubDataMaintenance();
                        } else {
                            this.equipmentInfoModal = true;
                        }
                    });
                } else {
                    this.clearData();
                }
            } else {
                if (this.temp === null) {
                    this.date_create_form = thaiDate;
                    this.date_update_form = thaiDate;

                    this.decodeToken = this.decodeJWT(localStorage.getItem('token'));
                    this.iev_organize = {
                        id: this.decodeToken.organize_id,
                        name: this.decodeToken.organize_name
                    };
                }

                this.equipmentGroupOptions = [
                    { system_id: 'vehicle', system_name: this.$i18n.t('vehicle') },
                    { system_id: 'device', system_name: this.$i18n.t('device') }
                ];
                if (this.selectedData == '') {
                    const lastest = new Date();
                    const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(lastest);
                    const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(lastest);
                    const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(lastest);
                    // var ye_th = Number(ye) + 543;
                    this.iev_update_info_date = `${da}/${mo}/${ye}`;
                    this.iev_update_info_date_save = `${ye}-${mo}-${da}`;

                    this.iev_equipment_group = {
                        system_id: 'device',
                        system_name: this.$i18n.t('device')
                    };
                    this.iev_equipment_type = {
                        system_id: 'gs-00000001',
                        system_name: 'เครื่องมืออุปกรณ์'
                    };
                    this.iev_equipment_status = {
                        id: '1',
                        name: this.$i18n.t('status_ready')
                    };
                }
            }
        },

        displayConfirmationCloseModal(val) {
            if (val == true) {
                this.equipmentInfoModal = true;
            }
        },

        async equipmentGroupSelected(val) {
            if (val !== null) {
                this.equipmentTypeSelected = null;
                this.equipmentTypeOptions = [];
                if (val != null) {
                    if (val.system_id == 'vehicle') {
                        this.disabledEquiptype = 0;
                        this.equipment_standard_name = null;

                        await this.axios
                            .post(`${this.$url_service}/initial/option`, {
                                body: { topic: 'gs-00000002', group: 'dg-23' }
                            })
                            .then((response) => {
                                this.standard_nameOptions = response.data.data;
                            });
                        await this.axios
                            .post(`${this.$url_service}/initial/option`, {
                                body: { group: 'dg-10' }
                            })
                            .then((response) => {
                                (this.iev_sideNum_Search = response.data.data),
                                    (this.equipmentTypeOptions = response.data.data),
                                    this.equipmentTypeOptions.splice(0, 0, {
                                        system_id: 'getall',
                                        system_name: this.$i18n.t('selectAll')
                                    });
                            });
                    } else if (val.system_id == 'device') {
                        this.disabledEquiptype = 0;
                        this.equipment_standard_name = null;
                        await this.axios
                            .post(`${this.$url_service}/initial/option`, {
                                body: { topic: 'gs-00000001', group: 'dg-23' }
                            })
                            .then((response) => {
                                // console.log('response =', response.data.data);

                                this.standard_nameOptions = response.data.data;
                            });
                    } else if (val.system_id == 'getall') {
                        this.equipment_standard_name = null;
                        await this.axios
                            .post(`${this.$url_service}/initial/option`, {
                                body: { group: 'dg-23' }
                            })
                            .then((response) => {
                                this.standard_nameOptions = response.data.data;
                            });
                        this.equipmentTypeSelected = {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        };
                    } else {
                        this.disabledEquiptype = 1;
                    }
                } else {
                    this.disabledEquiptype = 1;
                }
            }
        },

        async iev_equipment_group(val) {
            if (val.system_id == 'vehicle') {
                this.showDeviceOfVehicle = true;
                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-09' }
                    })
                    .then((response) => {
                        this.deviceTypeOptions = response.data.data;
                    });
                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-10' }
                    })
                    .then((response) => {
                        this.equipmentTypeOptions = response.data.data;
                    });
            } else {
                this.showDeviceOfVehicle = false;
                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-09' }
                    })
                    .then((response) => {
                        this.equipmentTypeOptions = response.data.data;
                        this.equipmentTypeOptions = this.equipmentTypeOptions.filter((item) => {
                            return !item.system_id.includes('gs-00000002');
                        });
                    });
            }
        },

        async equipmentTypeSelected(val) {
            this.equipment_standard_name = null;

            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { topic: 'gs-00000002', group: 'dg-23' }
                })
                .then((response) => {
                    this.standard_nameOptions = response.data.data;
                });

            this.iev_sideNum_Search_Selector = null;
            this.iev_sideNum_Search = null;

            if (!val) {
                this.iev_sideNum_Style = 'p-field p-col-12 p-lg-12 p-mt-2';
                return;
            }

            let filterWord = '';

            // if (val.system_id === 'gs-00000008') {
            //     filterWord = 'รถ';
            //     this.iev_sideNum_Style = 'p-field p-col-12 p-lg-6 p-mt-2';
            // } else if (val.system_id === 'gs-00000007') {
            //     filterWord = 'เรือ';
            //     this.iev_sideNum_Style = 'p-field p-col-12 p-lg-6 p-mt-2';
            // } else {
            //     this.iev_sideNum_Style = 'p-field p-col-12 p-lg-12 p-mt-2';
            // }

            if (val.system_id === 'gs-00000008') {
                filterWord = 'รถ';
                this.iev_sideNum_Style = 'p-field p-col-12 p-lg-6 p-mt-2';
            } else if (val.system_id === 'gs-00000007') {
                filterWord = 'เรือ';
                this.iev_sideNum_Style = 'p-field p-col-12 p-lg-6 p-mt-2';

                if (filterWord) {
                    const filteredOptions = this.standard_nameOptions.filter((item) => {
                        return (
                            item.maingroup_id === 'gs-00000002' &&
                            item.system_name.includes(filterWord) &&
                            !item.system_name.includes('รถบรรทุกเรือพร้อมเครนยก')
                        );
                    });
                    this.standard_nameOptions = [...filteredOptions];
                }
            } else {
                this.iev_sideNum_Style = 'p-field p-col-12 p-lg-12 p-mt-2';
            }
            if (filterWord) {
                const filteredOptions = this.standard_nameOptions.filter((item) => {
                    return item.maingroup_id === 'gs-00000002' && item.system_name.includes(filterWord);
                });

                filteredOptions.push({
                    system_id: 'filterOther',
                    system_name: 'อื่นๆ (ยานพาหนะ)'
                });

                this.standard_nameOptions = [...filteredOptions];

                await this.axios
                    .post(`${this.$url_service}/initial/equipment`, {
                        body: { topic: 'get-option-sidecar_number', ev_type: val.system_id }
                    })
                    .then((response) => {
                        this.iev_sideNum_Search = response.data.data;
                        this.iev_sideNum_Search.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                    });
            }
        },

        addDeviceOfVehicleModal(val) {
            if (val == false) {
                this.clearSubData();
            } else {
                this.FocusRef_delay('TextBox_1_Device', 'Input');
            }
        },

        // addMaintenanceHistoryEditModal(val) {
        //   if (val == false) {
        //     this.clearSubData();
        //   }
        // },

        addBorrowingHistoryModal(val) {
            if (val == false) {
                this.clearSubData();
            } else {
                this.FocusRef_delay('TextBox_1_Borrowing', 'Input');
            }
        },

        async iev_deviceOfVehicle_type(val) {
            if (val != null) {
                this.disable_iev_deviceOfVehicle_equipment = 0;
                await this.axios
                    .post(`${this.$url_service}/initial/device`, {
                        body: { topic: 'get-option-device', type: val.system_id }
                    })
                    .then((response) => (this.deviceOptions = response.data.data));
            } else {
                this.disable_iev_deviceOfVehicle_equipment = 1;
            }
        },

        selectedData(val) {
            if (val != '') {
                // console.log('selectedData : val.ev_status =',val.ev_status);
                if (val.ev_status == '1') {
                    this.iev_equipment_status = {
                        id: '1',
                        name: this.$i18n.t('status_ready')
                    };
                }
                if (val.ev_status == '2') {
                    this.iev_equipment_status = {
                        id: '2',
                        name: this.$i18n.t('status_fix')
                    };
                }
                if (val.ev_status == '3') {
                    this.iev_equipment_status = {
                        id: '3',
                        name: this.$i18n.t('status_bad')
                    };
                }
                if (val.ev_status == '4') {
                    this.iev_equipment_status = {
                        id: '4',
                        name: this.$i18n.t('status_waitSale')
                    };
                }
                if (val.ev_status == '5') {
                    this.iev_equipment_status = {
                        id: '5',
                        name: this.$i18n.t('status_sale')
                    };
                }
                if (val.ev_status == '6') {
                    this.iev_equipment_status = {
                        id: '6',
                        name: this.$i18n.t('status_bad_device')
                    };
                }
            }
        },

        iev_deviceOfVehicle_amount(val) {
            if (val == null) {
                this.iev_deviceOfVehicle_amount = 0;
            }
        },

        iev_historyOfMaintenance_startdate(val) {
            // console.log(val)
            if (val != '') {
                this.minDate = val;
                if (val == null) {
                    // this.iev_historyOfMaintenance_startdate = "";
                    this.iev_historyOfMaintenance_startdate = null;
                }
            } else {
                this.iev_historyOfMaintenance_enddate = '';
                this.maxDate = null;
                // this.maxDate = ""
            }
        },

        iev_historyOfMaintenance_enddate(val) {
            if (val != '') {
                this.maxDate = val;
                if (val == null) {
                    this.iev_historyOfMaintenance_enddate = '';
                }
            }
        },

        iev_historyOfBorrowing_startdate(val) {
            if (val != '') {
                this.minDate = val;
                if (val == null) {
                    this.iev_historyOfBorrowing_startdate = '';
                }
            } else {
                this.iev_historyOfBorrowing_enddate = '';
                this.maxDate = null;
                // this.maxDate = ""
            }
        },

        iev_historyOfBorrowing_enddate(val) {
            if (val != '') {
                this.maxDate = val;
                if (val == null) {
                    this.iev_historyOfBorrowing_enddate = '';
                }
            }
        },
        contact_phone(val) {
            // console.log(val)
            if (val.length == 0) {
                this.error_contact_phone = false;
            }
        },
        contact_phone_office(val) {
            // console.log(val)
            if (val.length == 0) {
                this.error_contact_phone_office = false;
                this.contact_phone_office_ext = '';
            }
        },
        // Doe PDF เลือกได้
        columnsSelector(val) {
            if (val.length == 0) {
                this.equipmentInfo_Table = [];
            } else {
                this.equipmentInfo_Table = this.cloneTable;
            }
        },

        addMaintenanceHistoryModal(val) {
            if (!val) {
                this.clearSubDataMaintenance();
                this.addMaintenanceHistoryModal = false;
                this.dataMainten = '';
            } else {
                this.FocusRef_delay('TextBox_1_Mainten', 'Input');
            }
        },
        addMaintenanceHistoryEditModal(val) {
            if (!val) {
                this.clearSubData();
                this.addMaintenanceHistoryEditModal = false;
                this.dataMaintenDetail = '';
            } else {
                this.FocusRef_delay('TextBox_1_maintenEdit', 'Input');
            }
        },

        MaintenanceEdit(val) {
            if (val) {
                for (let index = 0; index < val.length; index++) {
                    const element = val[index];
                    element['index'] = index + 1;
                }
            }
        },
        showOrganize(val) {
            if (val == true) {
                if (this.organize_table.length > 0) {
                    this.parentmessage_organize = this.organize_table;
                } else {
                    this.parentmessage_organize = [];
                }
            }
        }
    },
    created() {
        // Doe โหลด โทรศัพท์
        // Doe width 2/4
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        if (this.window.width <= 430) {
            this.searchMenu();
        } else {
            this.ms = true;
            this.searchMenu();
            // this.initialData();
        }
        // Doe โหลด โทรศัพท์

        // Doe PDF เลือกได้  4/5
        this.columnsSelector = this.columns;
        this.PDF_BodySizeSelect = this.PDF_BodySize;
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;

        for (let index = 0; index < this.columnsSelector.length; index++) {
            this.GetData_ColumnsSearch.push(this.columnsSelector[index].dataKey);
        }
        // Doe PDF เลือกได้  4/5  จบ

        const decodedToken = this.decodeJWT(localStorage.getItem('token'));
        // this.initialData();
        this.checkRole = decodedToken.permission_id;

        this.checkView_data = decodedToken.view_data;
        this.checkAdd_data = decodedToken.add_data;
        this.checkEdit_data = decodedToken.edit_data;
        this.checkDelete_data = decodedToken.delete_data;

        // console.log(`checkRole = ${this.checkRole} `);
        // console.log(`checkView_data = ${this.checkView_data} `);
        // console.log(`checkAdd_data = ${this.checkAdd_data} `);
        // console.log(`checkEdit_data = ${this.checkEdit_data} `);
        // console.log(`checkDelete_data = ${this.checkDelete_data} `);

        this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer);
    },

    // Doe โหลด โทรศัพท์
    // Doe width 3/4
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    // Doe โหลด โทรศัพท์,

    async mounted() {
        this.initialCommunityData();

        if (this.$route.query.code) {
            this.paramsQuery = this.$route.query.code;
            await this.searchEquipmentInfo();
            this.paramsQuery = '';
            this.$router.replace({ query: { ...this.$route.query, code: undefined } });
            // console.log(window.location.href);
            // console.log(this.$route.path)
        }
    },

    methods: {
        async initialCommunityData() {
            this.loading = true;
            try {
                const response = await this.axios.post(`${this.$url_service}/initial/community/option`, {});
                this.communityOptions = response.data.data;


            } catch (error) {
                console.error('Error fetching community options:', error);
            } finally {
                this.loading = false;
            }
        },

        async genCodeId() {
            if (this.iev_equipment_standard_name) {
                await this.axios
                    .post(`${this.$url_service}/initial/equipment`, {
                        body: {
                            topic: 'generatecode-equipment',
                            code: this.iev_equipment_standard_name
                        }
                    })
                    .then((response) => {
                        // console.log('response.data.data', response.data.newCode);
                        if (response.data.newCode) {
                            this.equipment_code = response.data.newCode;
                        }
                    });
            }
        },

        async updateDates() {
            try {
                this.loadingCreate = true;
                const userOrg = this.getUserOrganize();
                const userId = this.getUsername();

                // Format selected records
                const formattedRecords = this.selectedEquipmentInfo.map((item) => ({
                    ev_id: item.ev_id,
                    date_update: new Date().toISOString(),
                    ...item
                }));

                // console.log('formattedRecords', formattedRecords);

                const response = await this.axios.post(`${this.$url_service}/initial/equipment?user=${userId}`, {
                    body: {
                        topic: 'edit-equipment-date-multiple',
                        selectedEquipmentInfo: formattedRecords,
                        userOrg: userOrg
                    }
                });

                if (response.data.success) {
                    this.loadingCreate = false;
                    this.tempFor_displayConfirmationCloseModal = 'add';
                    this.FireHydrantModal = false;

                    // Show success message without confirmation button
                    await this.$fire({
                        type: 'success',
                        title: 'ปรับปรุงข้อมูล',
                        text: `อัปเดตข้อมูลอุปกรณ์ยานพาหนะจำนวน ${response.data.updatedIds.length} รายการ`,
                        timer: 3000,
                        showConfirmButton: false // Remove confirmation button
                    });

                    this.searchEquipmentInfo();
                }
            } catch (error) {
                this.loadingCreate = false;
                await this.$fire({
                    type: 'error',
                    title: 'เกิดข้อผิดพลาด',
                    text: error.response?.data?.message || 'ไม่สามารถอัปเดตข้อมูลได้',
                    timer: 3000,
                    showConfirmButton: false // Remove confirmation button
                });
            }
        },

        onSelectAll(checked) {
            if (checked) {
                this.selectedEquipmentInfo = [...this.equipmentInfo_Table];
            } else {
                this.selectedEquipmentInfo = [];
            }
            this.$emit('selectedEquipmentInfo', this.selectedEquipmentInfo);
        },
        onSelectRow(row, checked) {
            if (checked) {
                if (!this.selectedEquipmentInfo.some((item) => item.ev_id === row.ev_id)) {
                    this.selectedEquipmentInfo.push(row);
                }
            } else {
                this.selectedEquipmentInfo = this.selectedEquipmentInfo.filter((item) => item.ev_id !== row.ev_id);
            }
            this.$emit('selectedEquipmentInfo', this.selectedEquipmentInfo);
        },

        decodeJWT(token) {
            try {
                const payload = token.split('.')[1];
                // Replace Base64URL to Base64
                const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
                // Decode Base64
                const decodedPayload = atob(base64);
                // Handle UTF-8 encoding and return the parsed JSON object
                const jsonPayload = decodeURIComponent(
                    decodedPayload
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                );
                return JSON.parse(jsonPayload);
            } catch (error) {
                console.error('Failed to decode JWT token:', error);
                return null;
            }
        },

        updateEndDateMinDate() {
            // Check if a valid start date is selected
            if (this.iev_historyOfMaintenance_startdate) {
                // Clone the start date to avoid modifying it directly
                const minDate = new Date(this.iev_historyOfMaintenance_startdate);

                // Calculate the current year
                const currentYear = new Date().getFullYear();

                // Set the minimum date to the start date or the beginning of the current year, whichever is greater
                minDate.setFullYear(Math.max(minDate.getFullYear(), currentYear));

                // Update the minDate for the end date
                this.minEndDate = minDate;
            } else {
                // If no start date is selected, reset the minDate for the end date to null
                this.minEndDate = null;
            }

            // Reset the end date if it's no longer a valid selection based on the new minDate
            if (this.iev_historyOfMaintenance_enddate < this.minEndDate) {
                this.iev_historyOfMaintenance_enddate = null;
            }
        },

        saveData_Modal(ModalName) {
            if (ModalName === 'MaintenDetail') {
                this.saveHistory();
            } else if (ModalName === 'Mainten') {
                if (this.addMaintenanceHistoryEditModal === false) {
                    this.saveMaintenanceHistory();
                }
            } else if (ModalName === 'Modal_Main') {
                if (
                    this.addMaintenanceHistoryEditModal === false &&
                    this.addDeviceOfVehicleModal === false &&
                    this.addMaintenanceHistoryModal === false &&
                    this.addBorrowingHistoryModal === false &&
                    !this.isFocused('TextBox_2') &&
                    !this.isFocused('TextBox_3') &&
                    !this.isFocused('TextBox_5') &&
                    !this.isFocused('TextBox_6') &&
                    !this.isFocused('TextBox_17') &&
                    !this.isFocused('TextBox_18') &&
                    !this.isFocused('TextBox_19') &&
                    !this.isFocused('TextBox_20')
                ) {
                    this.saveData();
                }
            } else if (ModalName === 'addDevice') {
                this.saveDeviceData();
            } else if (ModalName === 'search') {
                if (!this.isFocused('TextBox_1_search') && !this.isFocused('TextBox_3_search')) {
                    // this.searchEquipmentInfo()
                    this.fastSearchEquipmentInfo;
                }
            } else if (ModalName === 'Borrowing') {
                this.saveHistoryBorrowing();
            }
        },
        exportCSV() {
            // debugger;
            this.$refs.dt.exportCSV();
        },
        // Doe โหลด โทรศัพท์
        // Doe width 4/4
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;

            this.table_BOXmanege = window.innerWidth > 700 ? 'p-field p-col' : '';
            this.table_editBTN = window.innerWidth > 700 ? this.$i18n.t('editBtn') : '';
            this.table_deleteBTN = window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '';
            if (window.innerWidth > 700) {
                this.table_headerStyle = this.checkInnerWidth('15rem', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('15rem', 'Body');
            } else {
                this.table_headerStyle = this.checkInnerWidth('105px', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('105px', 'Body');
            }

            const zoom = Math.round(window.devicePixelRatio * 100);
            this.zoomLevel = zoom;
            // this.setDialogScroll = {'overflow': this.zoomLevel < 175 ? 'visible' : 'auto'}
            if (this.$refs.maintenEdit_calendar !== null && this.$refs.maintenEdit_calendar !== undefined) {
                const width = this.$refs.maintenEdit_calendar.offsetWidth;
                if (width > 222) {
                    this.setDialogScroll = { overflow: 'auto' };
                } else {
                    this.setDialogScroll = { overflow: 'visible' };
                }
            }
        },
        setDiv_EGS(data) {
            if (data !== null) {
                if (data.system_id == `vehicle`) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        async searchMenu() {
            if (!this.checkToken()) {
                return;
            }
            // console.log('this.checkToken() = ', this.checkToken());
            // console.log("79")
            this.equipmentGroupOptions = [
                { system_id: 'getall', system_name: this.$i18n.t('selectAll') },
                { system_id: 'vehicle', system_name: this.$i18n.t('vehicle') },
                { system_id: 'device', system_name: this.$i18n.t('device') }
            ];

            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-23' }
                })
                .then((response) => {
                    this.standard_nameOptions = response.data.data;
                    // this.standard_nameOptions.splice(0, 0, {
                    //   system_name: this.$i18n.t("selectAll"),
                    // });
                    // console.log('this.standard_nameOptions = ',this.standard_nameOptions)
                });
            await this.axios
                .post(`${this.$url_service}/get/datagroup`, {
                    body: { topic: 'get-option-maingroup', datagroup: 'dg-09' }
                })
                .then((response) => {
                    this.unitNameOptions = response.data.data;
                });
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-27' }
                })
                .then((response) => {
                    this.brands = response.data.data;
                });
        },

        // Doe โหลด โทรศัพท์

        // Doe ค้นหา  3/6

        search() {
            if (this.filter != '') {
                this.equipmentInfo_Table = this.cloneTable.filter((item) => {
                    if (item.standard_name == null || item.standard_name == 'null') {
                        item.standard_name = '-';
                    }
                    if (item.ev_license_plate == null || item.ev_license_plate == 'null') {
                        item.ev_license_plate = '-';
                    }
                    if (item.ev_sidecar_number == null || item.ev_sidecar_number == 'null') {
                        item.ev_sidecar_number = '-';
                    }
                    if (item.ev_car_brand == null || item.ev_car_brand == 'null') {
                        item.ev_car_brand = '-';
                    }
                    if (item.ev_received_date == null || item.ev_received_date == 'null') {
                        item.ev_received_date = '-';
                    }

                    return (
                        (this.columns_ev_name ? (item.ev_name || '').includes(this.filter) : '') ||
                        (this.columns_status3 ? (item.code || '').includes(this.filter) : '') ||
                        (this.columns_ev_standard_name ? (item.standard_name || '').includes(this.filter) : '') ||
                        (this.columns_status1 ? (item.group || '').includes(this.filter) : '') ||
                        (this.columns_status2 ? (item.system_name || '').includes(this.filter) : '') ||
                        (this.columns_status5 ? (item.ev_number || '').includes(this.filter) : '') ||
                        (this.columns_status6 ? (item.ev_license_plate || '').includes(this.filter) : '') ||
                        (this.columns_total ? (item.ev_sidecar_number || '').includes(this.filter) : '') ||
                        (this.columns_ev_car_brand ? (item.ev_car_brand || '').includes(this.filter) : '') ||
                        (this.columns_ev_received_date ? (item.ev_received_date || '').includes(this.filter) : '') ||
                        (this.columns_organize_name ? (item.organize_name || '').includes(this.filter) : '') ||
                        (this.columns_status ? (item.status || '').includes(this.filter) : '') ||
                        (this.columns_ev_amount ? (item.ev_amount || '').includes(this.filter) : '') ||
                        (this.columns_ev_detail ? (item.ev_detail || '').includes(this.filter) : '') ||
                        (this.columns_ev_response_name ? (item.ev_response_name || '').includes(this.filter) : '') ||
                        (this.columns_text_tel_detail ? (item.text_tel_detail || '').includes(this.filter) : '') ||
                        (this.columns_user_fullname ? (item.user_fullname || '').includes(this.filter) : '') ||
                        (this.columns_date_create ? (item.date_create_ddmmyy || '').includes(this.filter) : '') ||
                        (this.columns_date_update ? (item.date_update_ddmmyy || '').includes(this.filter) : '') ||
                        (this.columns_ev_organize_name ? (item.organize_name || '').includes(this.filter) : '')
                    );
                });

                for (let i = 0; i < this.equipmentInfo_Table.length; i++) {
                    this.equipmentInfo_Table[i]['index'] = i + 1;
                }
                return this.equipmentInfo_Table;
            } else {
                this.equipmentInfo_Table = this.cloneTable;
                for (let i = 0; i < this.equipmentInfo_Table.length; i++) {
                    this.equipmentInfo_Table[i]['index'] = i + 1;
                }
            }

            this.equipmentInfo_Table = this.cloneTable;
        },

        // Doe ค้นหา  3/6 จบ
        async initialData() {
            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
            this.ms = true;
            this.filter = '';
            this.cloneTable = [];
            this.loading = true;
            await this.axios
                .post(`${this.$url_service}/get/datagroup`, {
                    body: { topic: 'get-option-maingroup', datagroup: 'dg-09' }
                })
                .then((response) => (this.unitNameOptions = response.data.data));
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-23' }
                })
                .then((response) => {
                    this.standard_nameOptions = response.data.data;
                    // this.standard_nameOptions.splice(0, 0, {
                    //   system_name: this.$i18n.t("selectAll"),
                    // });
                    // console.log('this.standard_nameOptions = ',this.standard_nameOptions)
                });

            await this.axios
                .post(`${this.$url_service}/initial/equipment`, {
                    body: {
                        topic: 'get-table',
                        userOrg
                    }
                })
                // Doe : เพิ่ม ลำดับ 3/4
                .then((response) => {
                    this.equipmentInfo_Table = response.data.data;
                    // Doe ค้นหา  4/6
                    this.cloneTable = response.data.data;
                    // Doe ค้นหา  4/6
                    // Doe ช่องว่างใส่ ขีด
                    this.formatData(this.equipmentInfo_Table);
                });
            // Doe : เพิ่ม ลำดับ 3/4 จบ
            if (this.columns_disabled == true) {
                this.equipmentInfo_Table = this.cloneTable;
            } else {
                this.equipmentInfo_Table = [];
            }

            this.equipmentGroupOptions = [
                { system_id: 'getall', system_name: this.$i18n.t('selectAll') },
                { system_id: 'vehicle', system_name: this.$i18n.t('vehicle') },
                { system_id: 'device', system_name: this.$i18n.t('device') }
            ];
            this.loading = false;
        },

        formatData(data) {
            for (let index = 0; index < data.length; index++) {
                data[index]['index'] = index + 1;
                if (data[index].ev_standard_name == null || data[index].ev_standard_name == 'null' || data[index].ev_standard_name == '') {
                    data[index].ev_standard_name = '-';
                }
                if (data[index].ev_number == null || data[index].ev_number == 'null' || data[index].ev_number == '') {
                    data[index].ev_number = '-';
                }
                if (data[index].ev_license_plate == null || data[index].ev_license_plate == 'null' || data[index].ev_license_plate == '') {
                    data[index].ev_license_plate = '-';
                }
                if (data[index].ev_sidecar_number == null || data[index].ev_sidecar_number == 'null' || data[index].ev_sidecar_number == '') {
                    data[index].ev_sidecar_number = '-';
                }
                if (data[index].ev_car_brand == null || data[index].ev_car_brand == 'null' || data[index].ev_car_brand == '') {
                    data[index].ev_car_brand = '-';
                }

                if (data[index].ev_received_date == null || data[index].ev_received_date == 'null' || data[index].ev_received_date == '') {
                    data[index].ev_received_date = '-';
                } else {
                    data[index].ev_received_date = this.changeDateToThai(new Date(data[index].ev_received_date));
                }

                if (data[index].ev_response_name == null || data[index].ev_response_name == 'null' || data[index].ev_response_name == '') {
                    data[index].ev_response_name = '-';
                }
                if (data[index].ev_response_phone == null || data[index].ev_response_phone == 'null' || data[index].ev_response_phone == '') {
                    data[index].ev_response_phone = '-';
                }
                if (data[index].ev_detail == null || data[index].ev_detail == 'null' || data[index].ev_detail == '') {
                    data[index].ev_detail = '-';
                }
                if (data[index].ev_sidecar_number == null || data[index].ev_sidecar_number == 'null' || data[index].ev_sidecar_number == '') {
                    data[index].ev_sidecar_number = '-';
                } else {
                    data[index].ev_sidecar_number = ` ${data[index].ev_sidecar_number}`;
                }

                if (data[index].date_create_ddmmyy == null || data[index].date_create_ddmmyy == 'null' || data[index].date_create_ddmmyy == '') {
                    data[index].date_create_ddmmyy = '-';
                } else {
                    data[index].date_create_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_create_ddmmyy));
                }

                if (data[index].date_update_ddmmyy == null || data[index].date_update_ddmmyy == 'null' || data[index].date_update_ddmmyy == '') {
                    data[index].date_update_ddmmyy = '-';
                } else {
                    data[index].date_update_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_update_ddmmyy));
                }
            }
        },
        closeAllModal() {
            // console.log("Close and don`t save data");
            this.equipmentInfoModal = false;
            this.displayConfirmationCloseModal = false;
            this.clearData();
        },

        acceptNumberPhone() {
            var x = this.contact_phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.contact_phone = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },
        acceptNumberPhone2() {
            var x = this.contact_phone_office.replace(/\D/g, '').match(/(\d{0,2})(\d{0,3})(\d{0,4})/);
            this.contact_phone_office = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },
        acceptNumberPhone3() {
            var x = this.contact_phone_office_ext.replace(/\D/g, '');
            this.contact_phone_office_ext = x;
        },
        acceptNumberPhone5() {
            var x = this.Maintenance_tel.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.Maintenance_tel = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },
        acceptNumberPhone6() {
            var x = this.Maintenance_count.replace(/\D/g, '');
            this.Maintenance_count = x;
        },
        acceptNumberEquipmentNumber() {
            var x = this.iev_equipment_number.replace(/\D/g, '').match(/(\d{0,4})(\d{0,8})(\d{0,8})(\d{0,5})/);
            this.iev_equipment_number = x[1] + (x[2] ? '-' + x[2] : '') + (x[3] ? '-' + x[3] : '') + (x[4] ? '-' + x[4] : '');
        },

        someHandler() {
            this.iev_equipment_type = null;
        },

        someHandler2() {
            this.iev_deviceOfVehicle_equipment = null;
        },

        clearImage() {
            this.url = null;
            this.pic = '';
            document.getElementById('iev_uploadImageFile').value = '';
        },

        onFileChange(e) {
            // const imgSize = this.$refs.file.files[0];

            document.getElementById('iev_uploadImageFile').click();
            if (e.type !== 'click') {
                if (e.target.files[0] != undefined) {
                    // const imgSize = e.target.files[0]
                    // if (imgSize.size > 7340032) {
                    //   this.$fire({
                    //         type: "warning",
                    //         title:"ขนาดไฟล์ใหญ่เกินไป",
                    //         text: "กรุณาใส่เฉพาะไฟล์รูปภาพไม่เกิน 7 MB.",
                    //         timer: 3000,
                    //         confirmButtonColor: '#28B463',
                    //       });
                    //       this.clearImage()

                    // }else {
                    if (e.target.files[0].type.split('/')[0] == 'image') {
                        this.pic = '';
                        const file = e.target.files[0];
                        this.url = URL.createObjectURL(file);

                        var reader = new FileReader();

                        reader.onload = (e) => {
                            var img = document.createElement('img');
                            img.onload = () => {
                                var canvas = document.createElement('canvas');
                                var ctx = canvas.getContext('2d');
                                ctx.drawImage(img, 0, 0);

                                var MAX_WIDTH = 250;
                                var MAX_HEIGHT = 250;
                                var width = img.width;
                                var height = img.height;

                                if (width > height) {
                                    if (width > MAX_WIDTH) {
                                        height *= MAX_WIDTH / width;
                                        width = MAX_WIDTH;
                                    }
                                } else {
                                    if (height > MAX_HEIGHT) {
                                        width *= MAX_HEIGHT / height;
                                        height = MAX_HEIGHT;
                                    }
                                }
                                canvas.width = width;
                                canvas.height = height;
                                ctx = canvas.getContext('2d');
                                ctx.drawImage(img, 0, 0, width, height);

                                var dataurl = canvas.toDataURL('image/png');
                                let console = {};
                                let logger = document.getElementById('iev_image');
                                console.log = (text) => {
                                    let txt = document.createTextNode(text);
                                    logger.appendChild(txt);
                                };
                                console.log(dataurl);
                            };
                            img.src = e.target.result;
                        };
                        reader.readAsDataURL(file);
                        this.pic = e.target.files[0].name;
                    } else {
                        // this.$toast.add({
                        //   severity: "error",
                        //   summary: "ประเภทไฟล์ผิดพลาด",
                        //   detail: "กรุณาใส่เฉพาะไฟล์รูปภาพเท่านั้น",
                        //   life: 3000,
                        // });
                        this.$fire({
                            type: 'error',
                            title: 'ประเภทไฟล์ผิดพลาด',
                            text: 'กรุณาใส่เฉพาะไฟล์รูปภาพเท่านั้น',
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });
                        this.url = null;
                        document.getElementById('iev_uploadImageFile').value = '';
                        this.pic = '';
                    }
                    // }
                } else {
                    this.pic = '';
                    this.url = null;
                }
            }
        },

        selectedOrganize_passValue_Form(variable) {
            this.showOrganize_Form = false;
            if (this.equipmentInfoModal == false) {
                this.selectedOrganize = {
                    id: variable.organize_id,
                    name: variable.organize_name
                };
            } else {
                this.iev_organize = {
                    id: variable.organize_id,
                    name: variable.organize_name
                };
            }
        },
        checkSelectedOrganize(status) {
            if (status !== '') {
                return true;
            } else {
                return false;
            }
        },
        selectedOrganize_passValue(variable) {
            this.showOrganize = false;
            if (variable != null) {
                if (this.setOpenModal_OrganizeMulti === 'search') {
                    this.organize_table = [];
                    for (let i = 0; i < variable.length; i++) {
                        this.organize_table.push({
                            organize_id: variable[i].organize_id,
                            organize_name: variable[i].organize_name
                        });
                    }
                }
            }
        },

        async searchEquipmentInfo() {
            this.columns_img_cloud = false;
            this.ms = true;
            // this.filter='';
            this.cloneTable = [];
            this.loading = true;
            // console.log('this.equipment_name', this.equipment_name);
            // console.log('this.selectedOrganize', (JSON.stringify(this.selectedOrganize)));
            var userSelectedOrganize = JSON.stringify(this.selectedOrganize);
            if (userSelectedOrganize != '{}') {
                // console.log('userSelectedOrganize != {} ', (JSON.parse(userSelectedOrganize)).id);
                userSelectedOrganize = JSON.parse(userSelectedOrganize).id;
            } else {
                // console.log('userSelectedOrganize ', userSelectedOrganize);
                userSelectedOrganize = this.selectedOrganize;
            }

            // console.log('this.getUserOrganize()', this.getUserOrganize());
            // console.log('this.checkPermission()', this.checkPermission());
            // console.log("this.equipment_standard_name", this.equipment_standard_name.system_name)
            // console.log(this.equipment_standard_name.map(data=>data.system_name))
            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
            await this.axios
                .post(`${this.$url_service}/initial/equipment`, {
                    body: {
                        topic: 'search-table',
                        name: this.equipment_name,
                        //  this.checkPermission() ==  true ให้ใช้ค่า  this.selectedOrganize ex. { id: 'or-000075', name: 'กองปฏิบัติการดับเพลิงและกู้ภัย 6' }
                        //  this.checkPermission() ==  false ให้ใช้ค่า  this.getUserOrganize() ex. or-000075
                        // organize: this.checkPermission() ? this.selectedOrganize : this.getUserOrganize(),
                        // organize: this.checkPermission() ? userSelectedOrganize : this.getUserOrganize(),
                        standard_name: this.equipment_standard_name === null ? '' : this.equipment_standard_name,
                        group: this.equipmentGroupSelected,
                        type: this.equipmentTypeSelected,
                        check: this.update_info,
                        // organize: userSelectedOrganize, // เช็คหน่วยงานหลัก
                        userOrg,
                        organize: this.organize_table,
                        sidecar_number:
                            this.iev_sideNum_Search_Selector !== null
                                ? this.iev_sideNum_Search_Selector.system_id !== 'getall'
                                    ? this.iev_sideNum_Search_Selector.system_name
                                    : ''
                                : '',
                        ev_status: this.iev_status_Search !== null ? this.iev_status_Search.id : ''
                    }
                })
                // Doe : เพิ่ม ลำดับ 4/4
                .then((response) => {
                    const newData = response.data.data.map((e) => {
                        if (e.ev_lat && e.ev_lon) {
                            e.ev_lat = Number(e.ev_lat).toFixed(6);
                            e.ev_lon = Number(e.ev_lon).toFixed(6);
                        }
                        return e;
                    });
                    this.equipmentInfo_Table = newData;
                    // Doe ค้นหา  4/6
                    this.cloneTable = newData;
                    // Doe ค้นหา  4/6

                    this.formatData(this.equipmentInfo_Table);
                    // this.search()

                    this.setSearchText_Footer();
                });
            // Doe : เพิ่ม ลำดับ 4/4 จบ

            if (this.columns_disabled == true) {
                this.equipmentInfo_Table = this.cloneTable;
            } else {
                this.equipmentInfo_Table = [];
            }

            this.search();
            this.loading = false;
        },
        async fastSearchEquipmentInfo() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());
            const isDistrict = this.decodeJWT.organize_id === 'or-000157' ? this.decodeJWT.username : '';

            this.columns_img = false;
            this.ms = true;
            // this.filter='';
            this.cloneTable = [];
            this.loading = true;
            // console.log('this.equipment_name', this.equipment_name);
            // console.log('this.selectedOrganize', (JSON.stringify(this.selectedOrganize)));
            var userSelectedOrganize = JSON.stringify(this.selectedOrganize);
            if (userSelectedOrganize != '{}') {
                // console.log('userSelectedOrganize != {} ', (JSON.parse(userSelectedOrganize)).id);
                userSelectedOrganize = JSON.parse(userSelectedOrganize).id;
            } else {
                // console.log('userSelectedOrganize ', userSelectedOrganize);
                userSelectedOrganize = this.selectedOrganize;
            }

            // console.log('this.getUserOrganize()', this.getUserOrganize());
            // console.log('this.checkPermission()', this.checkPermission());
            // console.log("this.equipment_standard_name", this.equipment_standard_name.system_name)
            // console.log(this.equipment_standard_name.map(data=>data.system_name))

            await this.axios
                .post(`${this.$url_service}/initial/equipment`, {
                    body: {
                        topic: 'fast-search-report-organize',
                        name: this.equipment_name,
                        //  this.checkPermission() ==  true ให้ใช้ค่า  this.selectedOrganize ex. { id: 'or-000075', name: 'กองปฏิบัติการดับเพลิงและกู้ภัย 6' }
                        //  this.checkPermission() ==  false ให้ใช้ค่า  this.getUserOrganize() ex. or-000075
                        // organize: this.checkPermission() ? this.selectedOrganize : this.getUserOrganize(),
                        // organize: this.checkPermission() ? userSelectedOrganize : this.getUserOrganize(),
                        standard_name: this.equipment_standard_name === null ? '' : this.equipment_standard_name,
                        group: this.equipmentGroupSelected,
                        type: this.equipmentTypeSelected,
                        check: this.update_info,
                        // organize: userSelectedOrganize, // เช็คหน่วยงานหลัก
                        organize: this.organize_table,
                        sidecar_number:
                            this.iev_sideNum_Search_Selector !== null
                                ? this.iev_sideNum_Search_Selector.system_id !== 'getall'
                                    ? this.iev_sideNum_Search_Selector.system_name
                                    : ''
                                : '',
                        ev_status: this.iev_status_Search !== null ? this.iev_status_Search.id : '',
                        code: this.ie_equipment_code,
                        equipment_community: this.ie_equipment_community !== null ? this.ie_equipment_community.community_name : '',
                        userOrg: this.checkPermission() ? null : this.getUserOrganize(), //เช็คสิทธิ์
                        isDistrict
                    }
                })
                // Doe : เพิ่ม ลำดับ 4/4
                .then((response) => {
                    const newData = response.data.data.map((e) => {
                        if (e.ev_lat && e.ev_lon) {
                            e.ev_lat = Number(e.ev_lat).toFixed(6);
                            e.ev_lon = Number(e.ev_lon).toFixed(6);
                        }
                        return e;
                    });
                    this.equipmentInfo_Table = newData;
                    // Doe ค้นหา  4/6
                    // console.log('response', newData);
                    this.cloneTable = newData;
                    // Doe ค้นหา  4/6

                    this.formatData(this.equipmentInfo_Table);
                    // this.search()

                    this.setSearchText_Footer();
                });
            // Doe : เพิ่ม ลำดับ 4/4 จบ

            if (this.columns_disabled == true) {
                this.equipmentInfo_Table = this.cloneTable;
            } else {
                this.equipmentInfo_Table = [];
            }

            this.search();
            this.loading = false;
        },

        setSearchText_Footer() {
            this.text_Footer = false;
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            if (
                this.organize_table.length !== 0 ||
                this.equipment_name !== '' ||
                this.iev_status_Search !== null ||
                this.equipmentGroupSelected !== null ||
                this.equipmentTypeSelected !== null ||
                this.iev_sideNum_Search_Selector !== null ||
                this.update_info.length !== 1
            ) {
                for (let index = 0; index < this.Data_text_Footer.length; index++) {
                    const element = this.Data_text_Footer[index];
                    if (element.DataName === 'หน่วยงานที่รับผิดชอบ' && this.organize_table.length !== 0) {
                        element.textShow = this.setAll_organize_table(this.organize_table);
                    }
                    if (element.DataName === 'ชื่อเครื่องมือฯ' && this.equipment_name !== '') {
                        element.textShow = this.equipment_name;
                    }
                    if (element.DataName === 'สถานะ' && this.iev_status_Search !== null) {
                        element.textShow = this.iev_status_Search.name;
                    }
                    if (element.DataName === 'กลุ่มเครื่องมือฯ' && this.equipmentGroupSelected !== null) {
                        element.textShow = this.equipmentGroupSelected.system_name;
                    }
                    if (element.DataName === 'ประเภทเครื่องมือฯ' && this.equipmentTypeSelected !== null) {
                        element.textShow = this.equipmentTypeSelected.system_name;
                    }
                    if (element.DataName === 'หมายเลขข้างรถ' && this.iev_sideNum_Search_Selector !== null) {
                        element.textShow = this.iev_sideNum_Search_Selector.system_name;
                    }
                    if (element.DataName === 'ต้องปรับปรุงข้อมูล' && this.update_info.length !== 1) {
                        element.textShow = this.update_info[0];
                    }
                }
                this.text_Footer = true;
            }
        },
        setAll_organize_table(data) {
            let text = [];
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                if (element.organize_name !== undefined) {
                    text += element.organize_name + ',';
                }
            }
            return text.slice(0, -1);
        },
        saveDeviceData() {
            if (
                this.iev_deviceOfVehicle_type == null ||
                this.iev_deviceOfVehicle_equipment == null ||
                this.iev_deviceOfVehicle_size == '' ||
                this.iev_deviceOfVehicle_amount == 0
            ) {
                if (this.iev_deviceOfVehicle_type == null) {
                    this.error_iev_deviceOfVehicle_type = true;
                }
                if (this.iev_deviceOfVehicle_equipment == null) {
                    this.error_iev_deviceOfVehicle_equipment = true;
                }
                if (this.iev_deviceOfVehicle_size == '') {
                    this.error_iev_deviceOfVehicle_size = true;
                }
                if (this.iev_deviceOfVehicle_amount == 0) {
                    this.error_iev_deviceOfVehicle_amount = true;
                }
            } else {
                this.addDeviceOfVehicleModal = false;
                this.deviceOfVehicle_table.push({
                    device_name: this.iev_deviceOfVehicle_equipment.device_name,
                    size: this.iev_deviceOfVehicle_size,
                    amount: this.iev_deviceOfVehicle_amount,
                    unit: this.iev_deviceOfVehicle_equipment.system_name
                });
            }
        },

        saveMaintenanceHistory() {
            let num = this.MaintenanceHistory.length;
            let id = '';

            if (this.MaintenanceHistory.length === 0) {
                id = 1;
            } else {
                id = parseInt(this.MaintenanceHistory[num - 1].id_report) + 1;
            }

            if (this.Maintenance_name == '' || this.Maintenance_tel == '') {
                if (this.Maintenance_name == '') {
                    this.error_Maintenance_name = true;
                }
                if (this.Maintenance_tel == '') {
                    this.error_Maintenance_tel = true;
                }
            } else {
                if (this.Maintenance_tel) {
                    if (this.Maintenance_tel === '-') {
                        this.error_Maintenance_tel = false;
                    } else if (this.Maintenance_tel.length !== 12) {
                        this.error_Maintenance_tel = true;
                    } else {
                        this.error_Maintenance_tel = false;
                    }
                } else {
                    this.error_Maintenance_tel = false;
                }
                if (!this.error_Maintenance_tel) {
                    if (this.dataMainten.length == '') {
                        for (let index = 0; index < this.MaintenanceEdit.length; index++) {
                            const element = this.MaintenanceEdit[index];

                            const no_report = element.no_report !== '' ? element.no_report : '-';
                            const repair = element.repair !== '' ? element.repair : '-';
                            const behavior = element.behavior !== '' ? element.behavior : '-';
                            const count = element.count !== '' ? element.count : '-';
                            const unit = element.unit !== '' ? element.unit : '-';
                            const startDate = element.start_date !== '' && element.start_date !== null ? element.start_date : '-';
                            const endDate = element.end_date !== '' ? element.end_date : '-';

                            const text = `ลำดับที่ : ${
                                index + 1
                            } เลขงาน : ${no_report}<br>รายการซ่อม: ${repair}<br>อาการที่พบ : ${behavior}<br>จำนวน : ${count}  หน่วยนับ : ${unit}<br>วันที่เข้าซ่อม : ${startDate}  <br>วันที่ปิดงาน : ${endDate}<br><br>`;
                            this.MaintenanceEdit_Text += text;
                        }

                        this.MaintenanceHistory.push({
                            id_report: id.toString(),
                            name: this.Maintenance_name,
                            tel: this.Maintenance_tel,
                            detail: this.MaintenanceEdit,
                            detail_text: this.MaintenanceEdit_Text
                        });
                        this.successSaveMaintenance();
                    } else {
                        this.MaintenanceEdit_Text = [];
                        for (let index = 0; index < this.MaintenanceEdit.length; index++) {
                            const element = this.MaintenanceEdit[index];

                            const no_report = element.no_report !== '' ? element.no_report : '-';
                            const repair = element.repair !== '' ? element.repair : '-';
                            const behavior = element.behavior !== '' ? element.behavior : '-';
                            const count = element.count !== '' ? element.count : '-';
                            const unit = element.unit !== '' ? element.unit : '-';
                            const startDate = element.start_date !== '' && element.start_date !== null ? element.start_date : '-';
                            const endDate = element.end_date !== '' ? element.end_date : '-';

                            const text = `ลำดับที่ : ${
                                index + 1
                            } เลขงาน : ${no_report}<br>รายการซ่อม: ${repair}<br>อาการที่พบ : ${behavior}<br>จำนวน : ${count}  หน่วยนับ : ${unit}<br>วันที่เข้าซ่อม : ${startDate}  <br>วันที่ปิดงาน : ${endDate}<br><br>`;
                            this.MaintenanceEdit_Text += text;
                        }

                        this.dataMainten[0].name = this.Maintenance_name;
                        this.dataMainten[0].tel = this.Maintenance_tel;
                        this.dataMainten[0].detail = this.MaintenanceEdit;
                        this.dataMainten[0].detail_text = this.MaintenanceEdit_Text;

                        this.successSaveMaintenance();
                    }
                    // console.log("this.MaintenanceHistory",this.MaintenanceHistory)
                }
            }
        },
        successSaveMaintenance() {
            this.MaintenanceEdit = [];
            this.clearSubDataMaintenance();
            this.addMaintenanceHistoryModal = false;
        },
        formatTimeMaintenance(time) {
            const element = time.split('/');

            const dateNew = new Date(`${element[1]}/${element[0]}/${element[2]}`);
            return moment(dateNew).locale('th').add(543, 'year').format('l');
        },
        saveHistory() {
            // if (
            //   this.iev_historyOfMaintenance_startdate == "" ||
            //   this.iev_historyOfMaintenance_enddate == ""
            // ) {
            //   if (this.iev_historyOfMaintenance_startdate == "") {
            //     this.error_iev_historyOfMaintenance_startdate = true;
            //   }
            //   if (this.iev_historyOfMaintenance_enddate == "") {
            //     this.error_iev_historyOfMaintenance_enddate = true;
            //   }
            // }
            // else {
            //   this.addMaintenanceHistoryEditModal = false;
            //   const start = new Date(this.iev_historyOfMaintenance_startdate);
            //   const ye1 = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
            //     start
            //   );
            //   const mo1 = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
            //     start
            //   );
            //   const da1 = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
            //     start
            //   );
            //   var ye1_th = Number(ye1) + 543;
            //   this.iev_historyOfMaintenance_startdate = `${da1}/${mo1}/${ye1_th}`;

            //   const end = new Date(this.iev_historyOfMaintenance_enddate);
            //   const ye2 = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
            //     end
            //   );
            //   const mo2 = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
            //     end
            //   );
            //   const da2 = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
            //     end
            //   );
            //   var ye2_th = Number(ye2) + 543;
            //   this.iev_historyOfMaintenance_enddate = `${da2}/${mo2}/${ye2_th}`;
            // }
            // this.historyOfMaintenance_table.push({
            //   startdate: this.iev_historyOfMaintenance_startdate,
            //   enddate: this.iev_historyOfMaintenance_enddate,
            //   detail: this.iev_historyOfMaintenance_detail,
            // });

            if (this.Maintenance_repair == '') {
                if (this.Maintenance_repair == '') {
                    this.error_Maintenance_repair = true;
                }
            } else {
                if (this.iev_historyOfMaintenance_startdate) {
                    const start = new Date(this.iev_historyOfMaintenance_startdate);
                    const ye1 = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(start);
                    const mo1 = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(start);
                    const da1 = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(start);
                    // var ye1_th = Number(ye1) + 543;
                    var ye1_th = Number(ye1);
                    this.iev_historyOfMaintenance_startdate = `${da1}/${mo1}/${ye1_th}`;
                }

                if (this.iev_historyOfMaintenance_enddate) {
                    const end = new Date(this.iev_historyOfMaintenance_enddate);
                    const ye2 = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(end);
                    const mo2 = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(end);
                    const da2 = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(end);
                    // var ye2_th = Number(ye2) + 543;
                    var ye2_th = Number(ye2);
                    this.iev_historyOfMaintenance_enddate = `${da2}/${mo2}/${ye2_th}`;
                }

                this.addMaintenanceHistoryEditModal = false;

                let num = this.MaintenanceEdit.length;
                let id = '';

                if (this.MaintenanceEdit.length === 0) {
                    id = 1;
                } else {
                    id = parseInt(this.MaintenanceEdit[num - 1].id) + 1;
                }
                if (this.dataMaintenDetail == '') {
                    this.MaintenanceEdit.push({
                        id: id.toString(),
                        repair: this.Maintenance_repair,
                        behavior: this.Maintenance_behavior,
                        count: this.Maintenance_count,
                        unit: this.Maintenance_unit ? this.Maintenance_unit.system_name : '',
                        no_report: this.Maintenance_no_report,
                        start_date: this.iev_historyOfMaintenance_startdate,
                        end_date: this.iev_historyOfMaintenance_enddate
                    });
                } else {
                    this.dataMaintenDetail[0].no_report = this.Maintenance_no_report;
                    this.dataMaintenDetail[0].repair = this.Maintenance_repair;
                    this.dataMaintenDetail[0].behavior = this.Maintenance_behavior;
                    this.dataMaintenDetail[0].count = this.Maintenance_count;
                    this.dataMaintenDetail[0].unit = this.Maintenance_unit ? this.Maintenance_unit.system_name : '';
                    this.dataMaintenDetail[0].start_date = this.iev_historyOfMaintenance_startdate;
                    this.dataMaintenDetail[0].end_date = this.iev_historyOfMaintenance_enddate;
                }
            }
            // console.log("this.MaintenanceEdit",this.MaintenanceEdit);
        },

        saveHistoryBorrowing() {
            if (this.iev_historyOfBorrowing_startdate == '' || this.iev_historyOfBorrowing_enddate == '') {
                if (this.iev_historyOfBorrowing_startdate == '') {
                    this.error_iev_historyOfBorrowing_startdate = true;
                }
                if (this.iev_historyOfBorrowing_enddate == '') {
                    this.error_iev_historyOfBorrowing_enddate = true;
                }
            } else {
                this.addBorrowingHistoryModal = false;
                const start = new Date(this.iev_historyOfBorrowing_startdate);
                const ye1 = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(start);
                const mo1 = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(start);
                const da1 = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(start);
                var ye1_th = Number(ye1) + 543;
                this.iev_historyOfBorrowing_startdate = `${da1}/${mo1}/${ye1_th}`;

                const end = new Date(this.iev_historyOfBorrowing_enddate);
                const ye2 = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(end);
                const mo2 = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(end);
                const da2 = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(end);
                var ye2_th = Number(ye2) + 543;
                this.iev_historyOfBorrowing_enddate = `${da2}/${mo2}/${ye2_th}`;
                this.ev_borrowing_history.push({
                    startdate: this.iev_historyOfBorrowing_startdate,
                    enddate: this.iev_historyOfBorrowing_enddate,
                    detail: this.iev_historyOfBorrowing_detail
                });

                // console.log(this.ev_borrowing_history);
            }
        },

        async confirmDelete() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            if (this.deleteAt == 'MaintenanceEdit-table') {
                this.MaintenanceEdit = this.MaintenanceEdit.filter((val) => val !== this.deleteMaintenanceEdit);
                this.displayConfirmation = false;
            } else if (this.deleteAt == 'device-table') {
                this.deviceOfVehicle_table = this.deviceOfVehicle_table.filter((val) => val !== this.deleteDevice);
                this.displayConfirmation = false;
            } else if (this.deleteAt == 'history-table') {
                this.MaintenanceHistory = this.MaintenanceHistory.filter((val) => val !== this.deleteHistory);
                this.displayConfirmation = false;
            } else if (this.deleteAt == 'history-Borrowing-table') {
                this.ev_borrowing_history = this.ev_borrowing_history.filter((val) => val !== this.deleteHistoryBorrowing);
            } else if (this.deleteAt == 'organize') {
                this.displayConfirmation = false;
                this.organize_table = this.organize_table.filter((val) => val !== this.organizeDelete);
            } else {
                const userId = this.getUsername();
                await this.axios
                    .post(`${this.$url_service}/initial/equipment?user=${userId}`, {
                        body: {
                            topic: 'delete-equipment',
                            id: this.temp
                        }
                    })
                    .then(() =>
                        // this.initialData()
                        this.fastSearchEquipmentInfo()
                    );
                this.displayConfirmation = false;
                // this.$toast.add({
                //   severity: "success",
                //   summary: "ลบข้อมูลสำเร็จ",
                //   detail: "ข้อมูลเครื่องมือ",
                //   life: 3000,
                // });
                this.$fire({
                    type: 'success',
                    title: 'ลบข้อมูลสำเร็จ',
                    text: 'ข้อมูลเครื่องมือ',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            }
        },

        async saveData() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());
            this.iev_phone = [
                {
                    phone: this.contact_phone == '' ? '-' : this.contact_phone,
                    tel: this.contact_phone_office == '' ? '-' : this.contact_phone_office,
                    tel_ext: this.contact_phone_office_ext == '' ? '-' : this.contact_phone_office_ext
                }
            ];

            // console.log(this.iev_phone)
            //Check null value
            if (
                this.iev_equipment_name == '' ||
                // this.iev_equipment_number == '' ||
                this.iev_equipment_group == null ||
                this.iev_equipment_type == null ||
                this.iev_organize.name == undefined ||
                this.iev_equipment_standard_name == null ||
                this.iev_equipment_standard_name == 'null'
            ) {
                if (this.iev_equipment_name == '') {
                    this.error_iev_equipment_name = true;
                }
                // if (this.iev_equipment_name == '') {
                //     this.error_iev_equipment_number = true;
                // }
                if (this.iev_equipment_group == null) {
                    this.error_iev_equipment_group = true;
                }
                if (this.iev_equipment_type == null) {
                    this.error_iev_equipment_type = true;
                }
                if (this.iev_organize.name == undefined) {
                    this.error_iev_organize = true;
                }
                if (this.iev_equipment_standard_name == null) {
                    this.error_iev_equipment_standard_name = true;
                }
                if (this.iev_equipment_standard_name == 'null') {
                    this.error_iev_equipment_standard_name = true;
                }
            } else {
                // if (this.iev_equipment_number) {
                //     this.iev_equipment_number = parseInt(this.iev_equipment_number.split('-').join('')).toString();
                // }
                if (this.contact_phone) {
                    if (this.contact_phone === '-') {
                        this.error_contact_phone = false;
                    } else if (this.contact_phone.length !== 12) {
                        this.error_contact_phone = true;
                    } else {
                        this.error_contact_phone = false;
                    }
                } else {
                    this.error_contact_phone = false;
                }
                if (this.contact_phone_office) {
                    if (this.contact_phone_office === '-') {
                        this.error_contact_phone_office = false;
                    } else if (this.contact_phone_office.length !== 11) {
                        this.error_contact_phone_office = true;
                    } else {
                        this.error_contact_phone_office = false;
                    }
                } else {
                    this.error_contact_phone_office = false;
                }

                if (!this.error_contact_phone && !this.error_contact_phone_office) {
                    const checkDate_received = this.checkDate(this.iev_received_date, '');
                    const date_received = checkDate_received === '' ? checkDate_received : this.changeDateToEN(checkDate_received, '-');

                    if (this.selectedData == '') {
                        // โหลดเพิ่มแก้ไข 4/8
                        this.loadingCreate = true;
                        // โหลดเพิ่มแก้ไข 4/8 จบ
                        // console.log(this.$refs.iev_image.innerText === '')

                        const userOrg = this.getUserOrganize(); //เช็คสิทธิ์
                        const userId = this.getUsername();

                        // console.log('this.equipment_community' , this.equipment_community)

                        await this.axios
                            .post(`${this.$url_service}/initial/equipment?user=${userId}`, {
                                body: {
                                    topic: 'add-equipment',
                                    userOrg,
                                    name: this.iev_equipment_name,
                                    ev_lat: this.iev_equipment_lat,
                                    ev_lon: this.iev_equipment_lon,
                                    image: this.$refs.iev_image.innerText === '' ? '-' : this.$refs.iev_image.innerText,
                                    organize: this.iev_organize.id,
                                    equipment_group: this.iev_equipment_group.system_id,
                                    equipment_type: this.iev_equipment_type.system_id,
                                    // iev_equipment_standard_name
                                    equipment_standard_name: this.iev_equipment_standard_name.system_name,
                                    equipment_number: this.iev_equipment_number,
                                    equipment_amount: parseFloat(this.iev_equipment_amount),
                                    status: this.iev_equipment_status.id,
                                    license_plate: this.iev_license_car,
                                    sidenumber: this.iev_sidecar_number,
                                    carbrand: this.iev_car_brand === null || this.iev_car_brand === undefined ? '' : this.iev_car_brand.system_name,
                                    received_date: date_received,
                                    latest_date: this.iev_update_info_date_save,
                                    response_name: this.iev_response_contact_name,
                                    response_position: this.iev_position,
                                    response_phone: this.iev_contact_phone,
                                    tel_detail: this.iev_phone,
                                    detail: this.iev_detail,
                                    history_table: this.historyOfMaintenance_table,
                                    history_table2: this.MaintenanceHistory == null ? [] : this.MaintenanceHistory,
                                    ev_borrowing_history: this.ev_borrowing_history,
                                    device_table: this.deviceOfVehicle_table,
                                    check: this.iev_update_info,
                                    code: this.equipment_code,
                                    equipment_community: this.equipment_community !== null ? this.equipment_community.community_name : '',
                                    editor: userId
                                }
                            })
                            .then(() => console.log('userId', userId))
                            .then(
                                () =>
                                    // this.initialData()
                                    this.fastSearchEquipmentInfo()
                                // console.log(res)
                            );
                        // โหลดเพิ่มแก้ไข 5/8
                        this.loadingCreate = false;
                        // โหลดเพิ่มแก้ไข 5/8 จบ

                        // this.$toast.add({
                        //   severity: "success",
                        //   summary: "เพิ่มข้อมูลสำเร็จ",
                        //   detail: "ข้อมูลเครื่องมือ",
                        //   life: 3000,
                        // });

                        this.$fire({
                            type: 'success',
                            title: 'เพิ่มข้อมูลสำเร็จ',
                            text: 'ข้อมูลเครื่องมือ',
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });
                        this.tempFor_displayConfirmationCloseModal = 'add';
                        this.equipmentInfoModal = false;
                    } else {
                        const lastest = new Date();
                        const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(lastest);
                        const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(lastest);
                        const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(lastest);
                        var new_latest_date = `${ye}-${mo}-${da}`;

                        var table;

                        if (this.iev_equipment_group.system_id == 'device') {
                            table = [];
                        } else {
                            table = this.deviceOfVehicle_table;
                        }

                        if (this.$refs.iev_image.innerText == '') {
                            this.$refs.iev_image.innerText = this.url;
                        } else {
                            this.$refs.iev_image.innerText = this.$refs.iev_image.innerText;
                        }

                        if (this.iev_equipment_standard_name.system_name == null || this.iev_equipment_standard_name.system_name == 'null') {
                            // this.error_iev_equipment_standard_name = true;
                        } else {
                            // โหลดเพิ่มแก้ไข 6/8 จบ
                            this.loadingCreate = true;
                            // โหลดเพิ่มแก้ไข 6/8 จบ
                            // console.log("this.MaintenanceHistory",this.MaintenanceHistory)
                            // console.log(this.$refs.iev_image.innerText)

                            const userOrg = this.getUserOrganize(); //เช็คสิทธิ์
                            const userId = this.getUsername();

                            await this.axios
                                .post(`${this.$url_service}/initial/equipment?user=${userId}`, {
                                    body: {
                                        topic: 'edit-equipment',
                                        userOrg,
                                        id: this.temp,
                                        name: this.iev_equipment_name,
                                        ev_lat: this.iev_equipment_lat,
                                        ev_lon: this.iev_equipment_lon,
                                        image: this.$refs.iev_image.innerText === '' ? '-' : this.$refs.iev_image.innerText,
                                        organize: this.iev_organize.id,
                                        equipment_group: this.iev_equipment_group.system_id,
                                        equipment_type: this.iev_equipment_type.system_id,
                                        // iev_equipment_standard_name
                                        equipment_standard_name: this.iev_equipment_standard_name
                                            ? this.iev_equipment_standard_name.system_name
                                            : '-',
                                        equipment_number: this.iev_equipment_number,
                                        equipment_amount: parseFloat(this.iev_equipment_amount),
                                        status: this.iev_equipment_status.id,
                                        license_plate: this.iev_license_car,
                                        sidenumber: this.iev_sidecar_number,
                                        carbrand:
                                            this.iev_car_brand === null || this.iev_car_brand === undefined ? '' : this.iev_car_brand.system_name,
                                        received_date: date_received,
                                        latest_date: new_latest_date,
                                        response_name: this.iev_response_contact_name,
                                        response_position: this.iev_position,
                                        response_phone: this.iev_contact_phone,
                                        tel_detail: this.iev_phone,
                                        detail: this.iev_detail,
                                        history_table: this.historyOfMaintenance_table,
                                        history_table2: this.MaintenanceHistory == null ? [] : this.MaintenanceHistory,
                                        ev_borrowing_history: this.ev_borrowing_history,
                                        device_table: table,
                                        check: this.iev_update_info,
                                        code: this.equipment_code,
                                        equipment_community: this.equipment_community !== null ? this.equipment_community.community_name : '',
                                        editor: userId
                                    }
                                })
                                .then(
                                    () =>
                                        // this.initialData()
                                        this.fastSearchEquipmentInfo()
                                    // console.log('Saved')
                                );
                            // โหลดเพิ่มแก้ไข 7/8 จบ
                            this.loadingCreate = false;
                            // โหลดเพิ่มแก้ไข 7/8 จบ

                            // this.$toast.add({
                            //   severity: "success",
                            //   summary: "แก้ไขข้อมูลสำเร็จ",
                            //   detail: "ข้อมูลเครื่องมือ",
                            //   life: 3000,
                            // });
                            this.$fire({
                                type: 'success',
                                title: 'แก้ไขข้อมูลสำเร็จ',
                                text: 'ข้อมูลเครื่องมือ',
                                timer: 3000,
                                confirmButtonColor: '#28B463'
                            });
                            this.equipmentInfoModal = false;
                        }
                    }
                }
            }
        },

        async editData(data) {
            if (!this.checkToken()) {
                return;
            }

            function toThaiDateFormat(dateString) {
                try {
                    // Split the date string by '/'
                    const [day, month, year] = dateString.split('/');

                    // Create a date object (months in JavaScript are 0-based, so subtract 1 from month)
                    const date = new Date(year, month - 1, day);

                    // Check if date is valid
                    if (isNaN(date.getTime())) {
                        return '-';
                    }

                    // Format options
                    const options = {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    };

                    // Convert to Thai date
                    return date.toLocaleDateString('th-TH', options);
                } catch (error) {
                    return '-';
                }
            }

            // console.log('this.checkToken() = ', this.checkToken());
            this.header = this.$i18n.t('iev_modal_title_edit');
            await this.axios
                .post(`${this.$url_service}/initial/equipment`, {
                    body: {
                        topic: 'showone-equipment',
                        id: data
                    }
                })
                .then((response) => {
                    // console.log(response)
                    // (console.log('!!!!!response.data.data =',response.data.data)),
                    (this.selectedData = response.data.data),
                        (this.equipment_community = {
                            community_id: response.data.data.equipment_community_id || '',
                            community_name: response.data.data.equipment_community
                        }),
                        (this.iev_equipment_lat = response.data.data.ev_lat),
                        (this.iev_equipment_lon = response.data.data.ev_lon),
                        (this.iev_equipment_name = response.data.data.ev_name),
                        (this.url = response.data.data.ev_image),
                        (this.iev_organize = {
                            id: response.data.data.organize_id,
                            name: response.data.data.organize_name
                        }),
                        (this.iev_equipment_group = {
                            system_id: response.data.data.ev_group,
                            system_name: this.$i18n.t(`${response.data.data.ev_group}`)
                        }),
                        (this.equipment_code = response.data.data.code == null ? '' : response.data.data.code);
                    (this.iev_equipment_type = {
                        system_id: response.data.data.ev_type,
                        system_name: response.data.data.system_name
                    }),
                        // iev_equipment_standard_name
                        (this.iev_equipment_standard_name = {
                            system_name: response.data.data.ev_standard_name
                        }),
                        // (this.iev_equipment_standard_name = response.data.data.standard_name),
                        (this.iev_equipment_number = response.data.data.ev_number),
                        (this.iev_equipment_amount = parseFloat(response.data.data.ev_amount)),
                        (this.iev_license_car = response.data.data.ev_license_plate),
                        (this.iev_sidecar_number = response.data.data.ev_sidecar_number),
                        (this.iev_car_brand =
                            response.data.data.ev_car_brand === null ||
                            response.data.data.ev_car_brand === '-' ||
                            response.data.data.ev_car_brand === ''
                                ? null
                                : { system_name: response.data.data.ev_car_brand }),
                        (this.iev_received_date = response.data.data.ev_received_date !== '' ? new Date(response.data.data.ev_received_date) : null),
                        // const date = response.data.data.ev_date
                        // this.iev_update_info_date = this.formatDateTH(date),
                        (this.iev_update_info_date = response.data.data.ev_date),
                        (this.iev_response_contact_name = response.data.data.ev_response_name),
                        (this.iev_position = response.data.data.ev_response_position),
                        (this.iev_contact_phone = response.data.data.ev_response_phone),
                        // (this.iev_phone = JSON.parse(response.data.data.tel_detail)),
                        // (this.contact_phone = this.iev_phone.phone),
                        // (this.contact_phone_office = this.iev_phone.tel),
                        // (this.contact_phone_office_ext = this.iev_phone.tel_ext),

                        (this.iev_phone = JSON.parse(response.data.data.tel_detail));
                    for (let index = 0; index < this.iev_phone.length; index++) {
                        const element = this.iev_phone[index];
                        this.contact_phone = element.phone;
                        this.contact_phone_office = element.tel;
                        this.contact_phone_office_ext = element.tel_ext;
                        // console.log("element.tel",element.tel)
                    }

                    (this.iev_detail = response.data.data.ev_detail),
                        (this.iev_update_info = [response.data.data.remind_check]),
                        (this.deviceOfVehicle_table = JSON.parse(response.data.data.ev_vehicledevice_table)),
                        (this.historyOfMaintenance_table = JSON.parse(response.data.data.ev_maintenance_table));
                    this.MaintenanceHistory = JSON.parse(response.data.data.ev_maintenance_table2);

                    // (this.MaintenanceHistory.push({
                    //   text_maintenanceHTML : response.data.data.text_maintenanceHTML
                    // }));

                    //  console.log("this.MaintenanceHistory",this.MaintenanceHistory),
                    this.ev_borrowing_history = JSON.parse(response.data.data.ev_borrowing_history);

                    this.date_create_form =
                        toThaiDateFormat(response.data.data.date_create_ddmmyy) == null
                            ? '-'
                            : toThaiDateFormat(response.data.data.date_create_ddmmyy);
                    this.date_update_form =
                        toThaiDateFormat(response.data.data.date_update_ddmmyy) == null
                            ? '-'
                            : toThaiDateFormat(response.data.data.date_update_ddmmyy);

                    // console.log(this.historyOfMaintenance_table);
                });
        },

        change_TextDetail(val) {
            const re = /\s*(?:<br>|$)\s*/;
            const mainten = val.split(re);
            let text_start = '';
            let date_mainStart = [];
            let date_mainEnd = [];
            for (let index = 0; index < mainten.length; index++) {
                date_mainStart.push(mainten[4].split('วันที่เข้าซ่อม : '));
                date_mainEnd.push(mainten[5].split('วันที่ปิดงาน : '));
                const element_start = date_mainStart[index][1].split('/');
                const dateStart = new Date(`${element_start[1]}/${element_start[0]}/${element_start[2]}`);
                const dateStatNew = moment(dateStart).locale('th').add(543, 'year').format('LL');
                const element_End = date_mainEnd[index][1].split('/');
                const dateEnd = new Date(`${element_End[1]}/${element_End[0]}/${element_End[2]}`);
                const dateEndNew = moment(dateEnd).locale('th').add(543, 'year').format('LL');
                text_start = `${mainten[0]}<br>${mainten[1]}<br>${mainten[2]}<br>${mainten[3]}<br>วันที่เข้าซ่อม : ${dateStatNew}<br>วันที่ปิดงาน : ${dateEndNew}<br><br>`;
            }

            return text_start;
        },
        formatDateTH(time) {
            let dateNew;
            for (let i = 0; i < time.length; i++) {
                const element = time.split('/');
                dateNew = new Date(`${element[1]}/${element[0]}/${element[2]}`);
            }
            return moment(dateNew).locale('th').add(543, 'year').format('DD/MM/YYYY');
        },
        editDataMaintenance(data) {
            this.hearder_Maintenance = 'แก้ไขข้อมูลประวัติการซ่อมบำรุง';
            this.dataMainten = this.MaintenanceHistory.filter((val) => {
                return val.id_report.match(data);
            });

            this.Maintenance_name = this.dataMainten[0].name;
            this.Maintenance_tel = this.dataMainten[0].tel;
            this.MaintenanceEdit = this.dataMainten[0].detail;
            this.MaintenanceEdit_Text = this.dataMainten[0].detail_text;
        },
        editDataMaintenanceDetail(data) {
            this.hearder_Maintenance_Edit = 'แก้ไขข้อมูลรายละเอียดการซ่อมบำรุง';
            this.dataMaintenDetail = this.MaintenanceEdit.filter((val) => {
                return val.id.match(data);
            });

            // console.log("dataMaintenDetail",this.dataMaintenDetail)

            this.Maintenance_no_report = this.dataMaintenDetail[0].no_report;
            this.Maintenance_repair = this.dataMaintenDetail[0].repair;
            this.Maintenance_behavior = this.dataMaintenDetail[0].behavior;
            this.Maintenance_count = this.dataMaintenDetail[0].count;
            this.Maintenance_unit = this.dataMaintenDetail[0].unit ? { system_name: this.dataMaintenDetail[0].unit } : null;

            if (this.dataMaintenDetail[0].start_date) {
                for (let i = 0; i < this.dataMaintenDetail.length; i++) {
                    const element = this.dataMaintenDetail[i].start_date.split('/');
                    let dateNew_start_date = new Date(`${element[1]}/${element[0]}/${element[2]}`);
                    this.iev_historyOfMaintenance_startdate = dateNew_start_date;
                }
            }

            if (this.dataMaintenDetail[0].end_date) {
                for (let i = 0; i < this.dataMaintenDetail.length; i++) {
                    const element2 = this.dataMaintenDetail[i].end_date.split('/');
                    let dateNew_end_date = new Date(`${element2[1]}/${element2[0]}/${element2[2]}`);
                    this.iev_historyOfMaintenance_enddate = dateNew_end_date;
                }
            }
        },
        clearData() {
            // console.log(' use clearData ' );
            this.dropdownClearFilerValue += 1;
            if (this.selectedData != '') {
                // console.log(' this.selectedData != "" ' );
                this.header = this.$i18n.t('iev_modal_title_add');
                this.temp = null;
                this.displayConfirmation = false;
                this.equipmentInfoModal = false;
                this.selectedData = '';
                this.setDefault();

                this.deviceTypeSelected = null;
                this.vehicleSelected = null;
                this.iev_equipment_standard_name = null;

                //Add data
            } else {
                // console.log(' this.selectedData == "" ' );
                this.temp = null;
                this.displayConfirmation = false;
                this.setDefault();
            }
        },

        setDefault() {
            this.equipment_code = '';
            this.iev_equipment_name = '';
            this.iev_equipment_group = {
                system_id: 'device',
                system_name: this.$i18n.t('device')
            };
            this.iev_equipment_status = {
                id: '1',
                name: this.$i18n.t('status_ready')
            };
            this.iev_equipment_standard_name = null;
            this.iev_equipment_type = null;
            this.iev_equipment_number = '';
            // this.iev_equipment_amount = 0;
            // เพิ่มส่วนจำนวนใหม่
            this.iev_equipment_amount = 0;
            this.iev_license_car = '';
            this.iev_response_contact_name = '';
            this.iev_position = '';
            this.iev_contact_phone = '';
            this.iev_detail = '';
            this.iev_sidecar_number = '';
            this.iev_car_brand = null;
            this.iev_received_date = null;
            this.iev_organize = '';
            this.iev_update_info = [];
            this.deviceOfVehicle_table = [];
            this.historyOfMaintenance_table = [];
            this.ev_borrowing_history = [];
            this.tempFor_displayConfirmationCloseModal = '';
            this.url = null;
            document.getElementById('iev_uploadImageFile').value = '';
            this.error_iev_equipment_name = false;
            this.error_iev_equipment_number = false;
            this.error_iev_equipment_group = false;
            this.error_iev_equipment_type = false;
            this.error_iev_organize = false;
            this.error_iev_equipment_standard_name = false;

            this.MaintenanceHistory = [];
            this.MaintenanceEdit = [];

            this.contact_phone = '';
            this.contact_phone_office = '';
            this.contact_phone_office_ext = '';

            this.error_contact_phone = false;
            this.error_contact_phone_office = false;
            this.error_contact_phone_office_ext = false;

            this.pic = '';

            this.date_create_form = '';
            this.date_update_form = '';
        },

        clearSubData() {
            this.dropdownClearFilerValue += 1;

            //device
            this.iev_deviceOfVehicle_type = null;
            this.iev_deviceOfVehicle_equipment = null;
            this.iev_deviceOfVehicle_size = '';
            this.iev_deviceOfVehicle_amount = 0;

            this.error_iev_deviceOfVehicle_type = false;
            this.error_iev_deviceOfVehicle_equipment = false;
            this.error_iev_deviceOfVehicle_size = false;
            this.error_iev_deviceOfVehicle_amount = false;

            //history
            // this.iev_historyOfMaintenance_startdate = "";
            // this.iev_historyOfMaintenance_enddate = "";
            this.iev_historyOfMaintenance_startdate = null;
            this.iev_historyOfMaintenance_enddate = null;
            this.iev_historyOfMaintenance_detail = '';
            this.error_iev_historyOfMaintenance_startdate = false;
            this.error_iev_historyOfMaintenance_enddate = false;

            this.hearder_Maintenance_Edit = 'เพิ่มข้อมูลรายละเอียดการซ่อมบำรุง';

            this.iev_historyOfBorrowing_startdate = '';
            this.iev_historyOfBorrowing_enddate = '';
            this.iev_historyOfBorrowing_detail = '';
            this.error_iev_historyOfBorrowing_startdate = false;
            this.error_iev_historyOfBorrowing_enddate = false;

            this.Maintenance_no_report = '';
            this.Maintenance_repair = '';
            this.error_Maintenance_repair = false;
            this.Maintenance_behavior = '';
            this.Maintenance_count = '';
            // this.Maintenance_unit="";
            this.Maintenance_unit = null;
        },

        clearSubDataMaintenance() {
            this.dropdownClearFilerValue += 1;
            this.error_Maintenance_tel = false;
            this.error_Maintenance_name = false;
            this.hearder_Maintenance = 'เพิ่มข้อมูลประวัติการซ่อมบำรุง';

            this.MaintenanceEdit_Text = [];
            this.MaintenanceEdit = [];
            this.Maintenance_name = '';
            this.Maintenance_tel = '';
        },

        async clearSearchField() {
            // console.log('clearSearchField')
            this.equipment_name = '';
            this.selectedOrganize = {};
            // this.equipmentGroupSelected = {
            //             system_id: "getall",
            //             system_name: this.$i18n.t("selectAll"),
            //           };
            this.equipmentGroupSelected = null;
            this.equipmentTypeSelected = null;
            this.iev_status_Search = null;
            this.iev_sideNum_Search = null;
            this.iev_sideNum_Search_Selector = null;
            this.organize_table = [];
            this.iev_equipment_standard_name = null;
            this.equipment_standard_name = null;
            this.dropdownClearFilerValue += 1;
            this.ie_equipment_community = null;

            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            this.text_Footer = false;

            // Doe ค้นหา
            this.filter = '';
            this.cloneTable = [];
            this.initialData();
            this.update_info = '0';

            // this.equipmentGroupSelected= {
            //             system_id: "getall",
            //             system_name: this.$i18n.t("placeholderSelectBox"),
            //           };
        },

        // Doe โหลด โทรศัพท์
        async MobileClearSearchField() {
            // console.log("this.ms3333",this.ms)
            if (this.ms == true) {
                this.clearSearchField();
            } else {
                // console.log("25")
                this.equipment_name = '';
                this.selectedOrganize = {};
                // this.equipmentGroupSelected = {
                //           system_id: "getall",
                //           system_name: this.$i18n.t("selectAll"),
                //         };
                this.equipmentGroupSelected = null;
                this.equipmentTypeSelected = null;
                this.iev_status_Search = null;
                this.iev_sideNum_Search = null;
                this.iev_sideNum_Search_Selector = null;
                this.organize_table = [];
                this.iev_equipment_standard_name = null;
                this.equipment_standard_name = null;
                this.update_info = '0';
                this.ie_equipment_community = null;
                this.equipmentGroupSelected = {
                    system_id: 'getall',
                    system_name: this.$i18n.t('placeholderSelectBox')
                    // system_name: this.$i18n.t("selectAll"),
                };

                this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
                this.text_Footer = false;

                this.dropdownClearFilerValue += 1;
                this.filter = '';
                this.cloneTable = [];
            }
        },
        // Doe โหลด โทรศัพท์

        // showImage(data) {
        //   // console.log('showImage(data) this.imgEquipment',this.imgEquipment)
        //   if (data.ev_image === null){
        //     this.imgEquipment = null;
        //   }
        //   else if (data.ev_image.includes("data:")) {
        //     this.imgEquipment = data.ev_image;

        //   } else {
        //     this.imgEquipment = null;
        //   }
        //   this.displayImageModal = true;
        // },

        showImage(data) {
            if (data === null) {
                this.imgTable = null;
            } else if (data) {
                this.imgTable = [data];
            } else {
                this.imgTable = null;
            }
            // console.log(this.imgTable[0].data)
            // console.log("responsiveOptions",this.responsiveOptions)
            // this.displayImageModal = true;
            this.displayBasic2 = true;
        },

        alertDisplay(temp, deleteAt) {
            this.$fire({
                title: 'ยืนยันการลบข้อมูล',
                text: 'คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?',

                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                // console.log(temp)
                if (result.value) {
                    // console.log(temp)
                    this.confirmDelete(temp, deleteAt);
                }
            });
        },
        // Doe PDF เลือกได้  5/5
        EditPDF() {
            this.displayEditPDF = true;
            this.columnsSelectorDialog = this.columnsSelector;
        },
        SaveEditPDF() {
            if (this.columnsSelectorDialog.length <= 4) {
                this.PDF_minCellWidthVer = 120;
                this.PDF_FontHeaderVer = 13;
                this.PDF_FontBodyVer = 11;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 }
                };
                if (this.columnsSelectorDialog.length == 4) {
                    this.PDF_BodySizeSelect = {
                        index: { cellWidth: 35 },

                        status: { cellWidth: 45 },
                        ev_amount: { cellWidth: 45 }
                    };
                }

                this.PDF_minCellWidthHor = 130;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 13;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            } else if (this.columnsSelectorDialog.length <= 6) {
                this.PDF_minCellWidthVer = 90;
                this.PDF_FontHeaderVer = 13;
                this.PDF_FontBodyVer = 11;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 },
                    ev_standard_name: { cellWidth: 120 },
                    status: { cellWidth: 45 },
                    ev_amount: { cellWidth: 45 }
                };
                if (this.columnsSelectorDialog.length == 6) {
                    this.PDF_BodySizeSelect = {
                        index: { cellWidth: 35 },

                        ev_standard_name: { cellWidth: 115 },

                        ev_sidecar_number: { cellWidth: 60 },

                        status: { cellWidth: 45 },
                        ev_amount: { cellWidth: 45 }
                    };
                }

                this.PDF_minCellWidthHor = 130;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 13;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            } else if (this.columnsSelectorDialog.length <= 10) {
                this.PDF_minCellWidthVer = 50;
                this.PDF_FontHeaderVer = 7.5;
                this.PDF_FontBodyVer = 5.5;
                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 30 },
                    ev_standard_name: { cellWidth: 85 },
                    system_name: { cellWidth: 60 },
                    ev_response_name: { cellWidth: 70 },
                    organize_name: { cellWidth: 55 },
                    // ev_number:{cellWidth:40},
                    ev_amount: { cellWidth: 40 }
                    // ev_detail:{cellWidth:48},
                };
                if (this.columnsSelectorDialog.length == 10) {
                    this.PDF_BodySizeSelect = {
                        index: { cellWidth: 30 },
                        ev_standard_name: { cellWidth: 85 },
                        system_name: { cellWidth: 60 },

                        ev_response_name: { cellWidth: 65 },
                        organize_name: { cellWidth: 55 },
                        ev_sidecar_number: { cellWidth: 55 },
                        ev_number: { cellWidth: 35 },
                        ev_detail: { cellWidth: 55 },

                        ev_amount: { cellWidth: 35 }
                    };
                }

                this.PDF_minCellWidthHor = 80;
                this.PDF_FontHeaderHor = 9;
                this.PDF_FontBodyHor = 7;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 },
                    ev_standard_name: { cellWidth: 90 },
                    organize_name: { cellWidth: 75 }
                };
            } else if (this.columnsSelectorDialog.length <= 13) {
                this.PDF_minCellWidthVer = 40;
                this.PDF_FontHeaderVer = 7.5;
                this.PDF_FontBodyVer = 5.5;
                this.PDF_BodySizeSelect = {
                    ev_name: { cellWidth: 38 },
                    ev_standard_name: { cellWidth: 57 },
                    group: { cellWidth: 40 },
                    system_name: { cellWidth: 38 },
                    ev_license_plate: { cellWidth: 35 },
                    ev_sidecar_number: { cellWidth: 37 },
                    text_tel_detail: { cellWidth: 28 },
                    // ev_response_phone:{cellWidth:28},
                    status: { cellWidth: 27 },
                    ev_detail: { cellWidth: 33 },
                    organize_name: { cellWidth: 45 },
                    ev_amount: { cellWidth: 25 },

                    ev_date: { cellWidth: 37 },

                    date_create_ddmmyy: { cellWidth: 35 },
                    date_update_ddmmyy: { cellWidth: 37 }
                };

                this.PDF_minCellWidthHor = 50;
                this.PDF_FontHeaderHor = 9;
                this.PDF_FontBodyHor = 7;

                this.PDF_BodySizeHorSelect = {
                    ev_license_plate: { cellWidth: 50 },

                    ev_standard_name: { cellWidth: 60 },
                    organize_name: { cellWidth: 70 },
                    group: { cellWidth: 60 },
                    system_name: { cellWidth: 60 },
                    ev_number: { cellWidth: 54 },
                    ev_detail: { cellWidth: 48 },
                    ev_sidecar_number: { cellWidth: 50 },
                    ev_date: { cellWidth: 55 },
                    date_update_ddmmyy: { cellWidth: 60 }
                };
            } else if (this.columnsSelectorDialog.length <= 14) {
                this.PDF_minCellWidthVer = 40;
                this.PDF_FontHeaderVer = 7.5;
                this.PDF_FontBodyVer = 5.5;
                this.PDF_BodySizeSelect = {
                    ev_name: { cellWidth: 38 },
                    ev_standard_name: { cellWidth: 50 },

                    system_name: { cellWidth: 38 },
                    ev_response_name: { cellWidth: 42 },
                    organize_name: { cellWidth: 45 },
                    ev_license_plate: { cellWidth: 35 },
                    ev_sidecar_number: { cellWidth: 37 },
                    text_tel_detail: { cellWidth: 28 },
                    // ev_response_phone:{cellWidth:28},
                    ev_detail: { cellWidth: 33 },
                    status: { cellWidth: 27 },
                    ev_amount: { cellWidth: 25 },

                    date_create_ddmmyy: { cellWidth: 35 },
                    date_update_ddmmyy: { cellWidth: 37 }
                };

                this.PDF_minCellWidthHor = 50;
                this.PDF_FontHeaderHor = 9;
                this.PDF_FontBodyHor = 7;

                this.PDF_BodySizeHorSelect = {
                    ev_name: { cellWidth: 60 },
                    ev_standard_name: { cellWidth: 85 },
                    group: { cellWidth: 60 },
                    system_name: { cellWidth: 60 },
                    organize_name: { cellWidth: 70 },
                    ev_number: { cellWidth: 55 },
                    ev_sidecar_number: { cellWidth: 55 },

                    status: { cellWidth: 40 },
                    text_tel_detail: { cellWidth: 40 },
                    // ev_response_phone:{cellWidth:40},
                    ev_detail: { cellWidth: 49 },

                    ev_amount: { cellWidth: 35 }
                };
            } else if (this.columnsSelectorDialog.length <= 15) {
                this.PDF_minCellWidthVer = 40;
                this.PDF_FontHeaderVer = 5.5;
                this.PDF_FontBodyVer = 5.5;
                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 21.5 },
                    ev_name: { cellWidth: 30 },
                    // ev_standard_name:{cellWidth:40},
                    ev_number: { cellWidth: 28 },
                    system_name: { cellWidth: 38 },
                    ev_response_name: { cellWidth: 42 },
                    organize_name: { cellWidth: 45 },
                    ev_license_plate: { cellWidth: 35 },
                    ev_sidecar_number: { cellWidth: 37 },
                    text_tel_detail: { cellWidth: 28 },
                    // ev_response_phone:{cellWidth:28},
                    ev_detail: { cellWidth: 27 },
                    status: { cellWidth: 22 },
                    ev_amount: { cellWidth: 21 },

                    date_create_ddmmyy: { cellWidth: 35 },
                    date_update_ddmmyy: { cellWidth: 34 }
                };

                this.PDF_minCellWidthHor = 50;
                this.PDF_FontHeaderHor = 9;
                this.PDF_FontBodyHor = 7;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 27 },
                    // ev_name:{cellWidth:60},
                    ev_standard_name: { cellWidth: 50 },
                    // group:{cellWidth:60},
                    system_name: { cellWidth: 60 },
                    organize_name: { cellWidth: 70 },
                    ev_number: { cellWidth: 40 },
                    ev_sidecar_number: { cellWidth: 35 },

                    status: { cellWidth: 40 },
                    text_tel_detail: { cellWidth: 40 },
                    // ev_response_phone:{cellWidth:40},
                    ev_detail: { cellWidth: 49 },

                    ev_amount: { cellWidth: 35 }
                };
            } else if (this.columnsSelectorDialog.length <= 16) {
                this.PDF_minCellWidthVer = 40;
                this.PDF_FontHeaderVer = 5.5;
                this.PDF_FontBodyVer = 5.5;
                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 21.5 },
                    ev_name: { cellWidth: 30 },
                    ev_standard_name: { cellWidth: 40 },
                    // group:{cellWidth:32},
                    system_name: { cellWidth: 38 },
                    ev_number: { cellWidth: 28 },

                    ev_sidecar_number: { cellWidth: 37 },
                    organize_name: { cellWidth: 45 },

                    text_tel_detail: { cellWidth: 28 },

                    ev_detail: { cellWidth: 27 },
                    ev_response_name: { cellWidth: 28 },

                    status: { cellWidth: 22 },
                    ev_amount: { cellWidth: 21 },
                    user_fullname: { cellWidth: 30 },

                    date_create_ddmmyy: { cellWidth: 35 },
                    date_update_ddmmyy: { cellWidth: 34 }
                };

                this.PDF_minCellWidthHor = 50;
                this.PDF_FontHeaderHor = 9;
                this.PDF_FontBodyHor = 7;

                this.PDF_BodySizeHorSelect = {
                    ev_standard_name: { cellWidth: 50 },

                    system_name: { cellWidth: 60 },
                    ev_number: { cellWidth: 40 },
                    ev_license_plate: { cellWidth: 50 },
                    ev_sidecar_number: { cellWidth: 35 },
                    organize_name: { cellWidth: 70 },

                    text_tel_detail: { cellWidth: 40 },

                    ev_detail: { cellWidth: 49 },
                    ev_response_name: { cellWidth: 39 },

                    status: { cellWidth: 40 },
                    ev_amount: { cellWidth: 35 },
                    ev_date: { cellWidth: 55 },

                    user_fullname: { cellWidth: 45 },
                    date_create_ddmmyy: { cellWidth: 35 },
                    date_update_ddmmyy: { cellWidth: 42 }
                };
            } else {
                this.PDF_minCellWidthVer = 38;
                this.PDF_FontHeaderVer = 5.5;
                this.PDF_FontBodyVer = 5.5;
                this.PDF_BodySizeSelect = this.PDF_BodySize;

                this.PDF_minCellWidthHor = 40;
                this.PDF_FontHeaderHor = 7;
                this.PDF_FontBodyHor = 7;

                this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
            }

            this.columnsSelector = this.columnsSelectorDialog;

            if (this.columnsSelectorDialog.length == 0) {
                this.columns_index = false;
                this.columns_img = false;
                this.columns_ev_name = false;
                this.columns_ev_standard_name = false;
                this.columns_ev_organize_name = false;
                this.columns_status1 = false;
                this.columns_status2 = false;
                this.columns_status5 = false;
                this.columns_status6 = false;
                this.columns_total = false;
                this.columns_ev_car_brand = false;
                this.columns_ev_received_date = false;
                this.columns_organize_name = false;
                this.columns_status = false;
                this.columns_ev_detail = false;
                this.columns_ev_amount = false;
                this.columns_ev_response_name = false;
                this.columns_text_tel_detail = false;
                // this.columns_ev_response_phone = false
                // this.columns_ev_date = false
                this.columns_user_fullname = false;

                this.columns_date_create = false;
                this.columns_date_update = false;

                this.columns_disabled = false;
            } else {
                this.columns_disabled = true;
                // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);

                this.GetData_ColumnsSearch = [];
                // ! จัดข้อมูล
                for (let index = 0; index < this.columnsSelector.length; index++) {
                    this.GetData_ColumnsSearch.push(this.columnsSelector[index].dataKey);
                }
                let getData = this.GetData_ColumnsSearch;

                // ! เช็คข้อมูล

                for (let index = 0; index < this.columnsSelector.length; index++) {
                    const element = this.columnsSelector[index].dataKey;

                    if (element == 'index') {
                        this.columns_index = true;
                    } else if (!getData.includes('index')) {
                        // console.log("getData.includes(index)",getData.includes("index"))
                        this.columns_index = false;
                    }

                    if (element == 'ev_image') {
                        this.columns_img = true;
                    } else if (!getData.includes('ev_image')) {
                        this.columns_img = false;
                    }

                    if (element == 'ev_name') {
                        this.columns_ev_name = true;
                    } else if (!getData.includes('ev_name')) {
                        this.columns_ev_name = false;
                    }

                    if (element == 'ev_standard_name') {
                        this.columns_ev_standard_name = true;
                    } else if (!getData.includes('ev_standard_name')) {
                        this.columns_ev_standard_name = false;
                    }

                    if (element == 'organize_name') {
                        this.columns_ev_organize_name = true;
                    } else if (!getData.includes('organize_name')) {
                        this.columns_ev_organize_name = false;
                    }

                    if (element == 'group') {
                        this.columns_status1 = true;
                    } else if (!getData.includes('group')) {
                        this.columns_status1 = false;
                    }

                    if (element == 'system_name') {
                        this.columns_status2 = true;
                    } else if (!getData.includes('system_name')) {
                        this.columns_status2 = false;
                    }

                    if (element == 'ev_number') {
                        this.columns_status5 = true;
                    } else if (!getData.includes('ev_number')) {
                        this.columns_status5 = false;
                    }

                    if (element == 'ev_license_plate') {
                        this.columns_status6 = true;
                    } else if (!getData.includes('ev_license_plate')) {
                        this.columns_status6 = false;
                    }

                    if (element == 'ev_sidecar_number') {
                        this.columns_total = true;
                    } else if (!getData.includes('ev_sidecar_number')) {
                        this.columns_total = false;
                    }

                    if (element == 'ev_car_brand') {
                        this.columns_ev_car_brand = true;
                    } else if (!getData.includes('ev_car_brand')) {
                        this.columns_ev_car_brand = false;
                    }

                    if (element == 'ev_received_date') {
                        this.columns_received_date = true;
                    } else if (!getData.includes('ev_received_date')) {
                        this.columns_received_date = false;
                    }

                    if (element == 'organize_name') {
                        this.columns_organize_name = true;
                    } else if (!getData.includes('organize_name')) {
                        this.columns_organize_name = false;
                    }

                    if (element == 'status') {
                        this.columns_status = true;
                    } else if (!getData.includes('status')) {
                        this.columns_status = false;
                    }

                    if (element == 'ev_detail') {
                        this.columns_ev_detail = true;
                    } else if (!getData.includes('ev_detail')) {
                        this.columns_ev_detail = false;
                    }

                    if (element == 'ev_amount') {
                        this.columns_ev_amount = true;
                    } else if (!getData.includes('ev_amount')) {
                        this.columns_ev_amount = false;
                    }

                    if (element == 'ev_response_name') {
                        this.columns_ev_response_name = true;
                    } else if (!getData.includes('ev_response_name')) {
                        this.columns_ev_response_name = false;
                    }

                    if (element == 'text_tel_detail') {
                        this.columns_text_tel_detail = true;
                    } else if (!getData.includes('text_tel_detail')) {
                        this.columns_text_tel_detail = false;
                    }

                    // if (element == "ev_response_phone") {
                    //   this.columns_ev_response_phone = true
                    // }else if(!getData.includes("ev_response_phone")){

                    //   this.columns_ev_response_phone = false
                    // }

                    // if (element == "ev_date") {
                    //   this.columns_ev_date = true
                    // }else if(!getData.includes("ev_date")){

                    //   this.columns_ev_date = false
                    // }

                    if (element == 'user_fullname') {
                        this.columns_user_fullname = true;
                    } else if (!getData.includes('user_fullname')) {
                        this.columns_user_fullname = false;
                    }

                    if (element == 'date_create_ddmmyy') {
                        this.columns_date_create = true;
                    } else if (!getData.includes('date_create_ddmmyy')) {
                        this.columns_date_create = false;
                    }

                    if (element == 'date_update_ddmmyy') {
                        this.columns_date_update = true;
                    } else if (!getData.includes('date_update_ddmmyy')) {
                        this.columns_date_update = false;
                    }
                }
            }

            this.displayEditPDF = false;
            this.filter = '';
        },
        CloseEditPDF() {
            this.displayEditPDF = false;
        },
        ClearEditPDF() {
            this.columnsSelectorDialog = [];
        },
        SelectAllEditPDF() {
            this.columnsSelectorDialog = this.columns;
        }
        // Doe PDF เลือกได้  5/5 จบ
    }
};
</script>
<style scoped>
.table_statusColor {
    color: #090073;
    display: inline-flex;
    padding: 5px 15px 5px 15px;
    font-weight: bolder;
    border-radius: 10px;
}
.table_row {
    text-align: center;
}

.imgDia {
    width: 100%;
    display: block;
}

@media screen and (min-width: 819px) and (max-width: 1200px) {
    #Search {
        width: 20rem;
    }
}
/* @media screen and (min-width: 538px){
      #Create{
      width: 146px;
    }
   
} */
#text_Foote {
    font-size: 1.2rem;
}
#Create {
    width: 149px;
}
#EX {
    width: 149px;
}
#PDF {
    width: 149px;
}
#TABLE_EDIT {
    width: 149px;
}
@media screen and (max-width: 818px) {
    #Search {
        width: 100%;
    }
}
.EquipV {
    width: 300px;
    white-space: normal;
}
@media screen and (max-width: 430px) {
    #Create {
        width: 50%;
    }
    #EX {
        width: 50%;
    }
    #PDF {
        width: 55%;
    }
    #TABLE_EDIT {
        width: 45%;
    }
    .EV_disasterOptions {
        width: 16.75rem;
        overflow-y: scroll;
    }
    .EV_disasterOptions::-webkit-scrollbar {
        width: 0;
        height: 1px;
    }

    .EV_disasterOptions::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    }

    .EV_disasterOptions::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    }
    .EquipV {
        width: 20rem;
        overflow-y: scroll;
    }
    .EquipV::-webkit-scrollbar {
        width: 0;
        height: 1px;
    }

    .EquipV::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    }

    .EquipV::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    }
}

.p-field {
    margin-bottom: 0rem;
}
#preview {
    display: flex;
    justify-content: center;
    align-items: center;
}

#preview img {
    width: 234px;
    border: solid 1px #cccccc;
}

.img-content {
    text-align: center;
}
</style>

<style>
/* โหลดเพิ่มแก้ไข 8/8*/

.From_Loading {
    position: absolute;
    top: 35vh;
    left: 42.5%;

    z-index: 1000;
}
@media screen and (max-width: 430px) {
    .From_Loading {
        position: absolute;
        top: 35vh;
        left: 30%;

        z-index: 1000;
    }
}
@keyframes p-progress-spinner-color {
    100%,
    0% {
        stroke: #75e9f4;
    }
    40% {
        stroke: #0057e7;
    }
    66% {
        stroke: #75e9f4;
    }
    80%,
    90% {
        stroke: #0057e7;
    }
}
.waveTextAnimated {
    margin-top: 0.6em;
    font-weight: bolder;
    margin-top: 0.5rem;
    font-size: 1.2rem;
    text-shadow: 1px 2px #78777794;
    text-align: center;
}
.waveTextAnimated span {
    display: inline-block;
    -webkit-animation: wave-text 1s ease-in-out infinite;
    animation: wave-text 1s ease-in-out infinite;
}
.waveTextAnimated span:nth-of-type(1) {
    -webkit-animation-delay: 0s;
    animation-delay: 0s;
}
.waveTextAnimated span:nth-of-type(2) {
    -webkit-animation-delay: 0.1s;
    animation-delay: 0.1s;
}
.waveTextAnimated span:nth-of-type(3) {
    -webkit-animation-delay: 0.2s;
    animation-delay: 0.2s;
}
.waveTextAnimated span:nth-of-type(4) {
    -webkit-animation-delay: 0.3s;
    animation-delay: 0.3s;
}
.waveTextAnimated span:nth-of-type(5) {
    -webkit-animation-delay: 0.4s;
    animation-delay: 0.4s;
}
.waveTextAnimated span:nth-of-type(6) {
    -webkit-animation-delay: 0.5s;
    animation-delay: 0.5s;
}
@-webkit-keyframes wave-text {
    00% {
        transform: translateY(0em);
    }
    60% {
        transform: translateY(-0.3em);
    }
    100% {
        transform: translateY(0em);
    }
}

@keyframes wave-text {
    00% {
        transform: translateY(0em);
    }
    60% {
        transform: translateY(-0.3em);
    }
    100% {
        transform: translateY(0em);
    }
}
/* โหลดเพิ่มแก้ไข ข้อมูล 8/8 จบ*/

.p-datatable-thead {
    border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
    border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
:deep(.p-datatable-wrapper table) {
    border-left: 1px solid #d6d4d4;
    border-right: 1px solid #d6d4d4;
    border-collapse: separate;
    border-spacing: 0;
}
:deep(.p-datatable-scrollable-header-table) {
    background-color: #d6d4d4;
}
:deep(.p-datatable-wrapper) {
    max-height: 550px;
    overflow: auto;
}
.p-multiselect {
    min-width: 15rem;
}

.multiselect-custom {
    // Doe PDF เลือกได้
    width: 100%;
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .item {
        display: flex;
        align-items: center;
    }

    .item-value {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 3px;
        display: inline-flex;
        margin-right: 0.5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);
    }
}
</style>
